export const Languages = {
    "en": {
        // sidebar
        "dashboard": "Dashboard",
        "business": "Business",
        "invoice": "Invoice",
        "customers": "Customers",
        "sold_items": "Sold Items",
        "expense": "Expense",
        "currency": "Currency",
        "sale_return": "Sales Return",
        "premium_access": "Premium Access",
        "valid_until": "Valid Until",

        // comman
        "view_all": "View All",
        "back": "Back",
        "add": "Add",
        "update": "Update",
        "cancel": "Cancel",
        "save": "Save",
        "edit": "Edit",
        "print": "Print",
        "download": "Download",
        "All": "All",
        "All_Business": "All Business",

        // Dashboard
        "bannerTitle": "BillNama - Manage Your Invoices, Items & Customers Effortlessly",
        "bannerDesc": "Easily track your daily invoices, manage items, and keep customer records in one place. BillNama streamlines your billing process, saves time, and helps you stay organized",
        "create_new": "Create New Invoice",
        "business_overview_Insights": "Business Overview & Insights",
        "total_earning": "Total Earning",
        "total_paid_earning": "Total Paid Earning",
        "total_unpaid_earning": "Total Unpaid Earning",
        "total_business": "Total Business",
        "total_invoices": "Total Invoices",
        "total_customers": "Total Customers",
        "total_sold_items": "Total Sold Items",
        "recent_invoice": "Recent Invoice",
        "total_earning": "Total Earning",
        "recent_businesses": "Recent Businesses",
        "paid_earning": "Paid Earning",
        "unpaid_earning": "Unpaid Earning",
        "total_expense": "Total Expense",
        "expense_view": "Expense View",

        "total_salereturn": "Total Sale Return",
        "Total_Earnings_Expense": "Total Earnings & Expense",
        "Session": "Session",
        "billing": "Billing",
        "Delete_My_Account": "Delete My Account",
        "Log_Out": "Log Out",




        // Business
        "business_list": "Business - List",
        "search_business": "Search Business...",
        "create_business": "Create Business",
        "business_logo": "Business Logo",
        "business_name": "Business Name",
        "gst_number": "GST Number",
        "invoice": "Invoice",
        "customers": "Customers",
        "issued_date": "Issued Date",
        "action": "Action",
        "entries_per_page": "entries per page",

        // view business
        "view_business": "View Business",
        "business_info": "Business Info",
        "address": "Address",
        "tc_account_details": "T&C / Account Details",

        // add/edit business
        "add_business": "Create New Business",
        "edit_business": "Edit Business",
        "business_name_error": "Please enter valid business name!",
        "enter_business_name": "Enter Business Name",
        "enter_gst_number": "Enter GST Number",
        "enter_address": "Enter Address",
        "enter_tc_account_details": "Enter T&C / Account Details",
        "business_add_success_message": "Business successfully created!",
        "business_add_failed_message": "Failed to create the business, Please try again!",
        "business_edit_success_message": "Business successfully updated!",
        "business_edit_failed_message": "Failed to update the business, Please try again!",
        "creation_Date": "Creation Date",

        // invoice 
        "invoice_list": "Invoice - List",
        "search_invoices": "Search invoices...",
        "create_invoices": "Create Invoice",
        "s_r": "S.R",
        "invoice_no": "Invoice No",
        "customer_name": "Customer Name",
        "amount": "Amount",
        "issued_date": "Issued Date",
        "status": "Status",
        "action": "Action",
        "paid": "Paid",
        "unpaid": "Unpaid",

        // add/edit invoice
        "add_invoice": "Create New Invoice",
        "edit_invoice": "Edit Invoice",
        "due_date": "Due Date",
        "items": "Items",
        "description": "Description",
        "qty": "Qty",
        "hours": "Hours",
        "price": "Price",
        "total": "Total",
        "action": "Action",
        "enter_item": "Enter Item",
        "enter_desc": "Enter Description",
        "item_error": "Please enter valid item!",
        "qty_error": "Please enter valid value!",
        "price_error": "Please enter valid price!",
        "add_new": "Add New",
        "note": "Note",
        "enter_note_here": "Enter Note Here...",
        "subtotal": "Subtotal",
        "discount": "Discount",
        "gst": "GST",
        "tax": "Tax",
        "payable_amount": "Net Amount",
        "igst": "IGST",
        "inoive_add_success_message": "Invoice successfully created!",
        "inoive_add_failed_message": "Failed to create the invoice, Please try again!",
        "inoive_edit_success_message": "Invoice successfully updated!",
        "inoive_edit_failed_message": "Failed to update the invoice, Please try again!",
        "invoice_delete_success_message": "Invoice successfully deleted!",
        "inoive_delete_failed_message": "Failed to delete invoice, Please try again!",
        "inoive_delete_conformation_text": "Are you sure you want to delete this invoice?",
        "inoive_delete_conformation": "Confirm Deletion",


        // preview
        "to": 'To',
        "billed_to": "Billed To",
        "BILLED_TO": "BILLED TO",
        "BILL_TO": "BILL TO",
        "date": "Date",
        "date_of_issue": "Date of Issue",
        "DATE_OF_ISSUE": "DATE OF ISSUE",
        "INVOICE": "INVOICE",
        "no": "No",
        "invoice_number": "Invoice Number",
        "INVOICE_NUMBER": "INVOICE NUMBER",
        "disc": "Disc",
        "signature_of": "Signature of",
        "terms": "Terms",
        "receiver_signature": "Receiver Signature",
        "INVOICE_TOTAL": "INVOICE TOTAL",
        "TAX_RATE": "TAX RATE",
        "TAX": "TAX",
        "TOTAL": "TOTAL",

        // customer
        "customers_list": "Customers - List",
        "search_customer": "Search customers...",
        "phone": "Phone",
        "total_amount": "Total Amount",
        "view_customer": "View Customer",
        "name": "Name",
        "GST": "GST",
        "related_invoices": "Related Invoices",

        // add/edit customer
        "add_customer": "Add Customer",
        "edit_customer": "Edit Customer",
        "customer_name": "Customer Name",
        "email": "Email",
        "phone_number": "Phone Number",
        "gst_number": "GST Number",
        "address": "Address",
        "enter_customer_name": "Enter Customer Name",
        "enter_email": "Enter Email",
        "enter_phone_number": "Enter Phone Number",
        "enter_gst_number": "Enter GST Number",
        "enter_address": "Enter Address",
        "customer_name_error": "Please enter valid name!",
        "customer_email_error": "Please enter valid email!",
        "customer_phone_number_error": "Please enter valid number!",
        "customer_edit_success_message": "Customer successfully updated!",
        "customer_edit_failed_message": "Failed to update the customer, Please try again!",

        // solditems - list
        "sold_items_list": "Sold Items - List",
        "search_item": "Search Items...",
        "quantity": "Quantity",
        "total": "Total",

        // expense
        "expense_list": "Expense - List",
        "Expense_Name": "Expense Name",
        "Expense_Date": "Expense Date",
        "Payment_Method": "Payment Method",
        "taxable_value": "Taxable Value",
        "supplier_gstin": "Supplier GSTIN",
        "itc_available": "ITC Available",
        "gst_purchase": "GST Purchase",
        "gst_rate": "GST Rate",
        "cgst": "CGST",
        "sgst": "SGST",
        "igst": "IGST",
        "Add_expense": "Add Expense",
        "Search_expenses": "Search Expenses..",
        "Expense_Category": "Expense Category",
        "Enter_Expense_Name": "Enter Name",
        "Enter_Expense_Description": "Enter Description",
        "Expense_add_success_message": "Expense successfully created!",
        "Expense_add_failed_message": "Failed to create the expense, Please try again!",
        "Expense_edit_success_message": "Expense successfully updated!",
        "Expense_edit_failed_message": "Failed to update the expense, Please try again!",
        "Expense_delete_success_message": "Expense successfully deleted!",
        "Expense_delete_failed_message": "Failed to delete expense, Please try again!",
        "Expense_delete_conformation_text": "Are you sure you want to delete this expense?",
        "expense_edit": "Edit Expense",
        "delete": "Delete",





        "cash": "Cash",
        "upi": "Upi",
        "cheque": "Cheque",
        "card": "Card",
        "electronics": "Electronics",



        //sale return
        "SaleReturn_List": "Sales Return - List",
        "SaleReturn_Search": "Search Sales Return...",
        "SaleReturn_add": "Sales Return Add",
        "SaleReturn_add_success_message": "SaleReturn successfully created!",
        "SaleReturn_add_failed_message": "Failed to create the SaleReturn, Please try again!",
        "SaleReturn_edit_success_message": "SaleReturn successfully updated!",
        "SaleReturn_edit_failed_message": "Failed to update the SaleReturn, Please try again!",
        "SaleReturn_delete_success_message": "SaleReturn successfully deleted!",
        "SaleReturn_delete_failed_message": "Failed to delete SaleReturn, Please try again!",
        "SaleReturn_delete_conformation_text": "Are you sure you want to delete this SaleReturn?",
        "SaleReturn_edit": "Edit SaleReturn",
        "SaleReturn_Reason": "SaleReturn Reason",
        "SaleReturn_Reason_enter": "Enter a reason",
        "SaleReturn_Reason_note": "Sales invoice was not paid, so no transaction will happen in this sale return.",


        //filter
        "today": "Today",
        "yesterday": "YesterDay",
        "last_7_days": "Last 7 Days",
        "this_month": "This Month",
        "last_month": "Last Month",
        "custome": "Custom",

        //days

        "sunday": "Sunday",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thrusday": "Thrusday",
        "friday": "Friday",
        "saturday": "Saturday",

        //currancy

        "Country_name": "Country Name",
        "Country_code": "Country Code",
        "Country_symbol": "Symbol",
        "Country_flag": "Flag",
        "search_by": "Search by Country or Currency Code"




    },
    "hi": {
        // साइडबार
        "dashboard": "डैशबोर्ड",
        "business": "व्यवसाय",
        "invoice": "इनवॉइस",
        "customers": "ग्राहक",
        "sold_items": "बेचे गए आइटम",
        "expense": "खर्च",
        "currency": "मुद्रा",
        "sale_return": "विक्रय वापसी",
        "premium_access": "प्रीमियम एक्सेस",
        "valid_until": "मान्य तिथि तक",



        // सामान्य
        "view_all": "सभी देखें",
        "back": "वापस",
        "add": "जोड़ें",
        "update": "अपडेट करें",
        "cancel": "रद्द करें",
        "save": "सहेजें",
        "edit": "संपादित करें",
        "print": "प्रिंट करें",
        "download": "डाउनलोड करें",
        "All": "सभी",
        "email": "ईमेल",
        "enter_email": "ईमेल दर्ज करें",
        "All_Business": "सभी व्यवसाय",

        // डैशबोर्ड
        "bannerTitle": "बिलनामा - अपनी इनवॉइस, आइटम और ग्राहकों को आसानी से प्रबंधित करें",
        "bannerDesc": "अपनी दैनिक इनवॉइस को आसानी से ट्रैक करें, आइटम का प्रबंधन करें और ग्राहक रिकॉर्ड एक ही स्थान पर रखें। बिलनामा आपके बिलिंग प्रोसेस को सुव्यवस्थित करता है, समय बचाता है और आपको संगठित रहने में मदद करता है।",
        "create_new": "नई इनवॉइस बनाएं",
        "business_overview_Insights": "व्यवसाय अवलोकन और अंतर्दृष्टि",
        "total_earning": "कुल आय",
        "total_paid_earning": "कुल भुगतान की गई आय",
        "total_unpaid_earning": "कुल अप्रदत्त आय",
        "total_business": "कुल व्यवसाय",
        "total_invoices": "कुल इनवॉइस",
        "total_customers": "कुल ग्राहक",
        "total_sold_items": "कुल बेचे गए आइटम",
        "recent_invoice": "हाल की इनवॉइस",
        "recent_businesses": "हाल के व्यवसाय",
        "paid_earning": "भुगतान की गई आय",
        "unpaid_earning": "अप्रदत्त आय",
        "total_expense": "कुल खर्च",
        "total_salereturn": "कुल विक्रय वापसी",
        "Total_Earnings_Expense": "कुल आय और खर्च",
        "Session": "सत्र",
        "billing": "भुगतान इतिहास",
        "Delete_My_Account": "मेरा खाता हटाएं",
        "Log_Out": "लॉग आउट",
        "Log_In": "लॉग इन",




        // व्यवसाय
        "business_list": "व्यवसाय - सूची",
        "search_business": "व्यवसाय खोजें...",
        "create_business": "व्यवसाय बनाएं",
        "business_logo": "व्यवसाय लोगो",
        "business_name": "व्यवसाय का नाम",
        "gst_number": "जीएसटी नंबर",
        "invoice": "इनवॉइस",
        "customers": "ग्राहक",
        "issued_date": "जारी करने की तारीख",
        "action": "क्रिया",
        "entries_per_page": "प्रति पृष्ठ प्रविष्टियाँ",

        // व्यवसाय देखें
        "view_business": "व्यवसाय देखें",
        "business_info": "व्यवसाय जानकारी",
        "address": "पता",
        "tc_account_details": "टी&सी / खाता विवरण",

        // व्यवसाय जोड़ें / संपादित करें
        "add_business": "नया व्यवसाय बनाएं",
        "edit_business": "व्यवसाय संपादित करें",
        "business_name_error": "कृपया वैध व्यवसाय नाम दर्ज करें!",
        "enter_business_name": "व्यवसाय का नाम दर्ज करें",
        "enter_gst_number": "जीएसटी नंबर दर्ज करें",
        "enter_address": "पता दर्ज करें",
        "enter_tc_account_details": "टी&सी / खाता विवरण दर्ज करें",
        "business_add_success_message": "व्यवसाय सफलतापूर्वक बनाया गया!",
        "business_add_failed_message": "व्यवसाय बनाने में असफल, कृपया पुनः प्रयास करें!",
        "business_edit_success_message": "व्यवसाय सफलतापूर्वक अपडेट किया गया!",
        "business_edit_failed_message": "व्यवसाय अपडेट करने में असफल, कृपया पुनः प्रयास करें!",

        // इनवॉइस
        "invoice_list": "इनवॉइस - सूची",
        "search_invoices": "इनवॉइस खोजें...",
        "create_invoices": "इनवॉइस बनाएं",
        "s_r": "क्रम संख्या",
        "invoice_no": "इनवॉइस नंबर",
        "customer_name": "ग्राहक का नाम",
        "amount": "राशि",
        "issued_date": "जारी करने की तारीख",
        "status": "स्थिति",
        "paid": "भुगतान किया गया",
        "unpaid": "अप्रदत्त",


        // इनवॉइस जोड़ें / संपादित करें
        "add_invoice": "नई इनवॉइस बनाएं",
        "edit_invoice": "इनवॉइस संपादित करें",
        "due_date": "नियत तिथि",
        "items": "आइटम",
        "description": "विवरण",
        "qty": "मात्रा",
        "hours": "घंटे",
        "price": "मूल्य",
        "total": "कुल",
        "enter_item": "आइटम दर्ज करें",
        "enter_desc": "विवरण दर्ज करें",
        "item_error": "कृपया वैध आइटम दर्ज करें!",
        "qty_error": "कृपया वैध मात्रा दर्ज करें!",
        "price_error": "कृपया वैध मूल्य दर्ज करें!",
        "add_new": "नया जोड़ें",
        "note": "नोट",
        "enter_note_here": "यहाँ नोट दर्ज करें...",
        "subtotal": "उप-योग",
        "discount": "छूट",
        "gst": "जीएसटी",
        "tax": "कर",
        "payable_amount": "देय राशि",
        "igst": "आईजीएसटी",
        "inoive_add_success_message": "इनवॉइस सफलतापूर्वक बनाई गई!",
        "inoive_add_failed_message": "इनवॉइस बनाने में विफल, कृपया पुनः प्रयास करें!",
        "inoive_edit_success_message": "इनवॉइस सफलतापूर्वक अपडेट की गई!",
        "inoive_edit_failed_message": "इनवॉइस अपडेट करने में विफल, कृपया पुनः प्रयास करें!",
        "phone_number": "फ़ोन नंबर",
        "creation_Date": "निर्माण तिथि",
        "enter_phone_number": "फोन नंबर दर्ज करें",
        "invoice_delete_success_message": "इनवॉइस सफलतापूर्वक हटाया गया!",
        "inoive_delete_failed_message": "इनवॉइस हटाने में विफल, कृपया पुनः प्रयास करें!",
        "inoive_delete_conformation_text": "क्या आप वाकई इस इनवॉइस को हटाना चाहते हैं?",
        "inoive_delete_conformation": "हटाने की पुष्टि करें",





        // पूर्वावलोकन
        "to": "को",
        "billed_to": "बिल किया गया",
        "date": "तारीख",
        "date_of_issue": "जारी करने की तारीख",
        "INVOICE": "इनवॉइस",
        "invoice_number": "इनवॉइस नंबर",
        "disc": "छूट",
        "signature_of": "हस्ताक्षर",
        "terms": "नियम और शर्तें",
        "receiver_signature": "प्राप्तकर्ता के हस्ताक्षर",
        "INVOICE_TOTAL": "कुल इनवॉइस",

        // ग्राहक
        "customers_list": "ग्राहक - सूची",
        "search_customer": "ग्राहकों को खोजें...",
        "phone": "फ़ोन",
        "total_amount": "कुल राशि",
        "view_customer": "ग्राहक देखें",
        "name": "नाम",
        "GST": "जीएसटी",
        "related_invoices": "संबंधित इनवॉइस",

        // बेचे गए आइटम
        "sold_items_list": "बेचे गए आइटम - सूची",
        "search_item": "आइटम खोजें...",
        "quantity": "मात्रा",
        "total": "कुल",

        // खर्च
        "expense_list": "खर्च - सूची",
        "Expense_Name": "खर्च का नाम",
        "Payment_Method": "भुगतान का तरीका",
        "taxable_value": "कर योग्य मूल्य",
        "supplier_gstin": "आपूर्तिकर्ता GSTIN",
        "itc_available": "ITC उपलब्ध",
        "gst_purchase": "GST खरीद",
        "gst_rate": "GST दर",
        "cgst": "CGST",
        "sgst": "SGST",
        "igst": "IGST",
        "Add_expense": "खर्च जोड़ें",
        "Search_expenses": "खर्च खोजें...",
        "Expense_Date": "खर्च की तारीख",
        "Expense_Category": "खर्च श्रेणी",
        "Enter_Expense_Name": "नाम दर्ज करें",
        "Enter_Expense_Description": "विवरण दर्ज करें",
        "Expense_add_success_message": "खर्च सफलतापूर्वक जोड़ा गया!",
        "Expense_add_failed_message": "खर्च जोड़ने में विफल, कृपया पुनः प्रयास करें!",
        "Expense_edit_success_message": "खर्च सफलतापूर्वक अपडेट किया गया!",
        "Expense_edit_failed_message": "खर्च अपडेट करने में विफल, कृपया पुनः प्रयास करें!",
        "Expense_delete_success_message": "खर्च सफलतापूर्वक हटाया गया!",
        "Expense_delete_failed_message": "खर्च हटाने में विफल, कृपया पुनः प्रयास करें!",
        "Expense_delete_conformation_text": "क्या आप वाकई इस खर्च को हटाना चाहते हैं?",
        "expense_view": "खर्च विवरण",
        "expense_edit": "खर्च संपादित करें",
        "delete": "हटाएं",





        "cash": "नकद",
        "upi": "यूपीआई",
        "cheque": "चेक",
        "card": "कार्ड",
        "electronics": "इलेक्ट्रॉनिक्स",




        // विक्रय वापसी
        "SaleReturn_List": "विक्रय वापसी - सूची",
        "SaleReturn_Search": "विक्रय वापसी खोजें...",
        "SaleReturn_add": "विक्रय वापसी जोड़ें",
        "SaleReturn_add_success_message": "विक्रय वापसी सफलतापूर्वक जोड़ी गई!",
        "SaleReturn_add_failed_message": "विक्रय वापसी जोड़ने में विफल, कृपया पुनः प्रयास करें!",
        "SaleReturn_edit_success_message": "विक्रय वापसी सफलतापूर्वक अपडेट की गई!",
        "SaleReturn_edit_failed_message": "विक्रय वापसी अपडेट करने में विफल, कृपया पुनः प्रयास करें!",
        "SaleReturn_delete_success_message": "विक्रय वापसी सफलतापूर्वक हटाई गई!",
        "SaleReturn_delete_failed_message": "विक्रय वापसी हटाने में विफल, कृपया पुनः प्रयास करें!",
        "SaleReturn_delete_conformation_text": "क्या आप वाकई इस विक्रय वापसी को हटाना चाहते हैं?",
        "SaleReturn_edit": "विक्रय वापसी संपादित करें",
        "SaleReturn_Reason": "विक्रय वापसी का कारण",
        "SaleReturn_Reason_enter": "एक कारण दर्ज करें",
        "SaleReturn_Reason_note": "बिक्री चालान का भुगतान नहीं किया गया था, इसलिए इस विक्रय वापसी में कोई लेन-देन नहीं होगा।",




        // फ़िल्टर
        "today": "आज",
        "yesterday": "कल",
        "last_7_days": "पिछले 7 दिन",
        "this_month": "इस माह",
        "last_month": "पिछले माह",
        "custome": "कस्टम",

        //days

        "sunday": "रविवार",
        "monday": "सोमवार",
        "tuesday": "मंगलवार",
        "wednesday": "बुधवार",
        "thursday": "गुरुवार",
        "friday": "शुक्रवार",
        "saturday": "शनिवार",

        //देश

        "Country_name": "देश का नाम",
        "Country_code": "देश कोड",
        "Country_symbol": "प्रतीक",
        "Country_flag": "झंडा",
        "search_by": "देश या मुद्रा कोड द्वारा खोजें"


    },
    "gu": {
        // સાઇડબાર
        "dashboard": "ડેશબોર્ડ",
        "business": "વ્યવસાય",
        "invoice": "ઇનવૉઇસ",
        "customers": "ગ્રાહકો",
        "sold_items": "વેચાયેલા વસ્તુઓ",
        "expense": "ખર્ચ",
        "currency": "કરન્સી",
        "sale_return": "વેચાણ પરત",
        "premium_access": "પ્રિમિયમ એક્સેસ",
        "valid_until": "માન્ય તારીખ સુધી",


        // સામાન્ય
        "view_all": "બધું જુઓ",
        "back": "પાછળ",
        "add": "ઉમેરો",
        "update": "અપડેટ કરો",
        "cancel": "રદ કરો",
        "save": "સાચવો",
        "edit": "સંપાદિત કરો",
        "print": "પ્રિન્ટ કરો",
        "download": "ડાઉનલોડ કરો",
        "All": "બધા",
        "email": "ઈમેલ",
        "All_Business": "બધા વ્યવસાય",


        // ડેશબોર્ડ
        "bannerTitle": "બિલનામા - તમારી ઇનવૉઇસ, વસ્તુઓ અને ગ્રાહકોને સરળતાથી વ્યવસ્થિત કરો",
        "bannerDesc": "તમારી દૈનિક ઇનવૉઇસને સરળતાથી ટ્રેક કરો, વસ્તુઓનું સંચાલન કરો અને ગ્રાહક રેકોર્ડ એકજ સ્થળે રાખો. બિલનામા તમારું બિલિંગ પ્રોસેસ સુગમ બનાવે છે, સમય બચાવે છે અને તમને સંસ્થા રહેવામાં મદદ કરે છે.",
        "create_new": "નવી ઇનવૉઇસ બનાવો",
        "business_overview_Insights": "વ્યવસાય અવલોકન અને અંદાજ",
        "total_earning": "કુલ આવક",
        "total_paid_earning": "કુલ ચૂકવાયેલ આવક",
        "total_unpaid_earning": "કુલ બાકી આવક",
        "total_business": "કુલ વ્યવસાય",
        "total_invoices": "કુલ ઇનવૉઇસ",
        "total_customers": "કુલ ગ્રાહકો",
        "total_sold_items": "કુલ વેચાયેલ વસ્તુઓ",
        "recent_invoice": "તાજેતરની ઇનવૉઇસ",
        "recent_businesses": "તાજેતરના વ્યવસાય",
        "paid_earning": "ચૂકવાયેલ આવક",
        "unpaid_earning": "બાકી આવક",
        "total_expense": "કુલ ખર્ચ",
        "total_salereturn": "કુલ વેચાણ પરત",
        "Total_Earnings_Expense": "કુલ આવક અને ખર્ચ",
        "Session": "સત્ર",
        "billing": "ચુકવણી ઇતિહાસ",
        "Delete_My_Account": "મારું ખાતું કાઢી નાંખો",
        "Log_Out": "લૉગ આઉટ",
        "Log_In": "લૉગ ઇન",
        


        // business
        "business_list": "વ્યવસાય - યાદી",
        "search_business": "વ્યવસાય શોધો...",
        "create_business": "વ્યવસાય બનાવો",
        "business_logo": "વ્યવસાય લોગો",
        "business_name": "વ્યવસાયનું નામ",
        "gst_number": "જીએસટી નંબર",
        "invoice": "બીલ",
        "customers": "ગ્રાહકો",
        "issued_date": "બનાવાની તારીખ",
        "action": "ક્રિયા",
        "entries_per_page": "દર પૃષ્ઠ એન્ટ્રીઓ",

        // view business
        "view_business": "વ્યવસાય જુઓ",
        "business_info": "વ્યવસાય માહિતી",
        "address": "સરનામું",
        "tc_account_details": "નિયમો અને શરતો / એકાઉન્ટ વિગતો",

        // add/edit business
        "add_business": "વ્યવસાય ઉમેરો",
        "edit_business": "વ્યવસાય અપડેટ કરો",
        "business_name_error": "કૃપા કરીને માન્ય વ્યવસાયનું નામ દાખલ કરો!",
        "enter_business_name": "વ્યવસાયનું નામ દાખલ કરો",
        "enter_gst_number": "જીએસટી નંબર દાખલ કરો",
        "enter_address": "સરનામું દાખલ કરો",
        "enter_tc_account_details": "નિયમો અને શરતો / એકાઉન્ટ વિગતો દાખલ કરો",
        "business_add_success_message": "વ્યવસાય સફળતાપૂર્વક બનાવાયો!",
        "business_add_failed_message": "વ્યવસાય બનાવવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "business_edit_success_message": "વ્યવસાય સફળતાપૂર્વક અપડેટ થયો!",
        "business_edit_failed_message": "વ્યવસાય અપડેટ કરવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો!",

        // બીલ
        "invoice_list": "બીલ - યાદી",
        "search_invoices": "બીલ શોધો...",
        "create_invoices": "બીલ બનાવો",
        "s_r": "ક્રમ સંખ્યા",
        "invoice_no": "બીલ નંબર",
        "customer_name": "ગ્રાહકનું નામ",
        "amount": "રકમ",
        "issued_date": "બનાવાની તારીખ",
        "status": "સ્થિતિ",
        "action": "ક્રિયા",
        "paid": "ચૂકવાયેલ",
        "unpaid": "બાકી",
        "creation_Date": "બનાવવાની તારીખ",


        // add/edit invoice
        "add_invoice": "નવું બીલ બનાવો",
        "edit_invoice": "બીલ અપડેટ કરો",
        "due_date": "ચુકવણીની તારીખ",
        "items": "વસ્તુઓ",
        "description": "વર્ણન",
        "qty": "જથ્થો",
        "hours": "કલાકો",
        "price": "ભાવ",
        "total": "કુલ",
        "action": "ક્રિયા",
        "enter_item": "વસ્તુ દાખલ કરો",
        "enter_desc": "વર્ણન દાખલ કરો",
        "item_error": "કૃપા કરીને માન્ય વસ્તુ દાખલ કરો!",
        "qty_error": "કૃપા કરીને માન્ય જથ્થો દાખલ કરો!",
        "price_error": "કૃપા કરીને માન્ય ભાવ દાખલ કરો!",
        "add_new": "નવું ઉમેરો",
        "note": "નોંધ",
        "enter_note_here": "અહિયાં નોંધ દાખલ કરો...",
        "subtotal": "પેટા કુલ",
        "discount": "છૂટ",
        "gst": "જીએસટી",
        "tax": "કર",
        "payable_amount": "ચૂકવવાપાત્ર રકમ",
        "igst": "આઈજીએસટી",
        "inoive_add_success_message": "બીલ સફળતાપૂર્વક ઉમેરાયું!",
        "inoive_add_failed_message": "બીલ બનાવવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "inoive_edit_success_message": "બીલ સફળતાપૂર્વક અપડેટ થયું!",
        "inoive_edit_failed_message": "બીલ અપડેટ કરવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "invoice_delete_success_message": "ઇન્વૉઇસ સફળતાપૂર્વક કાઢી નાખવામાં આવી!",
        "inoive_delete_failed_message": "ઇન્વૉઇસ કાઢી નાખવામાં નિષ્ફળ રહ્યો, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "inoive_delete_conformation_text": "શું તમે ખરેખર આ ઇન્વૉઇસ કાઢી નાખવા માંગો છો?",
        "inoive_delete_conformation": "કાઢી નાખવાની પુષ્ટિ કરો",


        // preview
        "to": "સુધી",
        "billed_to": "બિલ મેળવનાર",
        "BILLED_TO": "બિલ મેળવનાર",
        "BILL_TO": "બિલ મેળવનાર",
        "date": "તારીખ",
        "date_of_issue": "જારી કરવાની તારીખ",
        "DATE_OF_ISSUE": "જારી કરવાની તારીખ",
        "INVOICE": "બિલ",
        "no": "ક્રમ",
        "invoice_number": "બીલ નંબર",
        "INVOICE_NUMBER": "બીલ નંબર",
        "disc": "છૂટ",
        "signature_of": "સહી",
        "terms": "શરતો",
        "receiver_signature": "પ્રાપ્તકર્તાની સહી",
        "INVOICE_TOTAL": "કુલ બીલ રકમ",
        "TAX_RATE": "કર દર",
        "TAX": "કર",
        "TOTAL": "કુલ",

        // customer 
        "customers_list": "ગ્રાહકો - યાદી",
        "search_customer": "ગ્રાહકો શોધો...",
        "phone": "ફોન",
        "total_amount": "કુલ રકમ",
        "view_customer": "ગ્રાહક જુઓ",
        "name": "નામ",
        "GST": "જીએસટી",
        "related_invoices": "સંબંધિત ચલણ",

        // add/edit customer
        "add_customer": "ગ્રાહક ઉમેરો",
        "edit_customer": "ગ્રાહક અપડેટ કરો",
        "customer_name": "ગ્રાહકનું નામ",
        "email": "ઇમેઇલ",
        "phone_number": "ફોન નંબર",
        "gst_number": "જીએસટી નંબર",
        "address": "સરનામું",
        "enter_customer_name": "ગ્રાહકનું નામ દાખલ કરો",
        "enter_email": "ઇમેઇલ દાખલ કરો",
        "enter_phone_number": "ફોન નંબર દાખલ કરો",
        "enter_gst_number": "જીએસટી નંબર દાખલ કરો",
        "enter_address": "સરનામું દાખલ કરો",
        "customer_name_error": "કૃપા કરીને માન્ય નામ દાખલ કરો!",
        "customer_email_error": "કૃપા કરીને માન્ય ઇમેઇલ દાખલ કરો!",
        "customer_phone_number_error": "કૃપા કરીને માન્ય નંબર દાખલ કરો!",
        "customer_edit_success_message": "ગ્રાહક સફળતાપૂર્વક અપડેટ થયો!",
        "customer_edit_failed_message": "ગ્રાહક અપડેટ કરવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો!",

        // solditems - list
        "sold_items_list": "વેચાયેલા વસ્તુઓ - યાદી",
        "search_item": "વસ્તુઓ શોધો...",
        "quantity": "જથ્થો",
        "total": "કુલ",

        "expense_list": "ખર્ચ - યાદી",
        "Expense_Name": "ખર્ચનું નામ",
        "Payment_Method": "ચુકવણી પદ્ધતિ",
        "Add_expense": "ખર્ચ ઉમેરો",
        "Search_expenses": "ખર્ચ શોધો...",
        "Expense_Date": "ખર્ચની તારીખ",
        "Expense_Category": "ખર્ચ શ્રેણી",
        "Enter_Expense_Name": "નામ દાખલ કરો",
        "Enter_Expense_Description": "વર્ણન દાખલ કરો",
        "Expense_add_success_message": "ખર્ચ સફળતાપૂર્વક બનાવવામાં આવ્યો!",
        "Expense_add_failed_message": "ખર્ચ બનાવવામાં નિષ્ફળ રહ્યો, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "Expense_edit_success_message": "ખર્ચ સફળતાપૂર્વક અપડેટ કરવામાં આવ્યો!",
        "Expense_edit_failed_message": "ખર્ચ અપડેટ કરવામાં નિષ્ફળ રહ્યો, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "Expense_delete_success_message": "ખર્ચ સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો!",
        "Expense_delete_failed_message": "ખર્ચ કાઢી નાખવામાં નિષ્ફળ રહ્યો, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "Expense_delete_conformation_text": "શું તમે ખરેખર આ ખર્ચ કાઢી નાખવા માંગો છો?",
        "expense_edit": "ખર્ચ સંપાદિત કરો",
        "delete": "કાઢી નાંખો",


        "cash": "નગદ",
        "upi": "યુપીઆઈ",
        "cheque": "ચેક",
        "card": "કાર્ડ",
        "electronics": "ઇલેક્ટ્રોનિક્સ",

        // વેચાણ વળતર
        "SaleReturn_List": "વેચાણ વળતર - યાદી",
        "SaleReturn_Search": "વેચાણ વળતર શોધો...",
        "SaleReturn_add": "વિક્રય વાપસી ઉમેરો",
        "SaleReturn_add_success_message": "વિક્રય વાપસી સફળતાપૂર્વક બનાવવામાં આવી!",
        "SaleReturn_add_failed_message": "વિક્રય વાપસી બનાવવામાં નિષ્ફળ ગયું, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "SaleReturn_edit_success_message": "વિક્રય વાપસી સફળતાપૂર્વક અપડેટ કરવામાં આવી!",
        "SaleReturn_edit_failed_message": "વિક્રય વાપસી અપડેટ કરવામાં નિષ્ફળ ગયું, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "SaleReturn_delete_success_message": "વિક્રય વાપસી સફળતાપૂર્વક કાઢી નાખવામાં આવી!",
        "SaleReturn_delete_failed_message": "વિક્રય વાપસી કાઢી નાખવામાં નિષ્ફળ ગયું, કૃપા કરીને ફરી પ્રયાસ કરો!",
        "SaleReturn_delete_conformation_text": "શું તમે ખરેખર આ વિક્રય વાપસી કાઢી નાખવા માંગો છો?",
        "SaleReturn_edit": "વિક્રય વાપસી સંપાદિત કરો",
        "SaleReturn_Reason": "વિક્રય વાપસીનું કારણ",
        "SaleReturn_Reason_enter": "કારણ દાખલ કરો",
        "SaleReturn_Reason_note": "વેચાણની ઇન્વૉઇસ માટે ચુકવણી કરવામાં આવેલી નથી, તેથી આ વિક્રય વાપસીમાં કોઈ ટ્રાન્ઝેક્શન નહીં થાય.",


        // ફિલ્ટર
        "today": "આજ",
        "yesterday": "ગઈકાલ",
        "last_7_days": "છેલ્લા 7 દિવસ",
        "this_month": "આ મહિનો",
        "last_month": "છેલ્લો મહિનો",
        "custome": "કસ્ટમ",

        // દિવસો
        "sunday": "રવિવાર",
        "monday": "સોમવાર",
        "tuesday": "મંગળવાર",
        "wednesday": "બુધવાર",
        "thursday": "ગુરુવાર",
        "friday": "શુક્રવાર",
        "saturday": "શનિવાર",

        // દેશ
        "Country_name": "દેશનું નામ",
        "Country_code": "દેશ કોડ",
        "Country_symbol": "પ્રતીક",
        "Country_flag": "ધ્વજ",
        "search_by": "દેશ અથવા ચલણ કોડ દ્વારા શોધો"


    },
    "fr": {
        // Barre latérale
        "dashboard": "Tableau de bord",
        "business": "Entreprise",
        "invoice": "Facture",
        "customers": "Clients",
        "sold_items": "Articles vendus",
        "expense": "Dépense",
        "currency": "Devise",
        "sale_return": "Retour de vente",
        "premium_access": "Accès Premium",
        "valid_until": "Valide jusqu'à",

        // Général
        "view_all": "Voir tout",
        "back": "Retour",
        "add": "Ajouter",
        "update": "Mettre à jour",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "edit": "Modifier",
        "print": "Imprimer",
        "download": "Télécharger",
        "All": "Tous",
        "email": "E-mail",
        "All_Business": "Toutes les entreprises",

        // Tableau de bord
        "bannerTitle": "Bilanama - Gérez facilement vos factures, articles et clients",
        "bannerDesc": "Suivez facilement vos factures quotidiennes, gérez vos articles et conservez les enregistrements des clients en un seul endroit. Bilanama simplifie votre processus de facturation, vous fait gagner du temps et vous aide à rester organisé.",
        "create_new": "Créer une nouvelle facture",
        "business_overview_Insights": "Aperçu et analyses des entreprises",
        "total_earning": "Revenu total",
        "total_paid_earning": "Revenu total payé",
        "total_unpaid_earning": "Revenu total impayé",
        "total_business": "Total des entreprises",
        "total_invoices": "Total des factures",
        "total_customers": "Total des clients",
        "total_sold_items": "Total des articles vendus",
        "recent_invoice": "Facture récente",
        "recent_businesses": "Entreprises récentes",
        "paid_earning": "Revenu payé",
        "unpaid_earning": "Revenu impayé",
        "total_expense": "Dépense totale",
        "total_salereturn": "Total des retours de vente",
        "Total_Earnings_Expense": "Revenus et dépenses totaux",
        "Session": "Session",
        "billing": "Historique des paiements",
        "Delete_My_Account": "Supprimer mon compte",
        "Log_Out": "Se déconnecter",
        "Log_In": "Se connecter",


        // Entreprise
        "business_list": "Liste des entreprises",
        "search_business": "Rechercher une entreprise...",
        "create_business": "Créer une entreprise",
        "business_logo": "Logo de l'entreprise",
        "business_name": "Nom de l'entreprise",
        "gst_number": "Numéro de TVA",
        "invoice": "Facture",
        "customers": "Clients",
        "issued_date": "Date d'émission",
        "action": "Action",
        "entries_per_page": "Entrées par page",

        // Voir entreprise
        "view_business": "Voir l'entreprise",
        "business_info": "Informations sur l'entreprise",
        "address": "Adresse",
        "tc_account_details": "Conditions générales / Détails du compte",

        // Ajouter/Modifier entreprise
        "add_business": "Ajouter une entreprise",
        "edit_business": "Modifier l'entreprise",
        "business_name_error": "Veuillez entrer un nom d'entreprise valide!",
        "enter_business_name": "Saisir le nom de l'entreprise",
        "enter_gst_number": "Saisir le numéro de TVA",
        "enter_address": "Saisir l'adresse",
        "enter_tc_account_details": "Saisir les conditions générales / Détails du compte",
        "business_add_success_message": "Entreprise créée avec succès!",
        "business_add_failed_message": "Échec de la création de l'entreprise, veuillez réessayer!",
        "business_edit_success_message": "Entreprise mise à jour avec succès!",
        "business_edit_failed_message": "Échec de la mise à jour de l'entreprise, veuillez réessayer!",

        // Facture
        "invoice_list": "Liste des factures",
        "search_invoices": "Rechercher une facture...",
        "create_invoices": "Créer une facture",
        "s_r": "N° de série",
        "invoice_no": "Numéro de facture",
        "customer_name": "Nom du client",
        "amount": "Montant",
        "issued_date": "Date d'émission",
        "status": "Statut",
        "action": "Action",
        "paid": "Payée",
        "unpaid": "Impayée",

        // Ajouter/Modifier facture
        "add_invoice": "Créer une facture",
        "edit_invoice": "Modifier la facture",
        "due_date": "Date d'échéance",
        "items": "Articles",
        "description": "Description",
        "qty": "Quantité",
        "hours": "Heures",
        "price": "Prix",
        "total": "Total",
        "action": "Action",
        "enter_item": "Saisir un article",
        "enter_desc": "Saisir une description",
        "item_error": "Veuillez entrer un article valide!",
        "qty_error": "Veuillez entrer une quantité valide!",
        "price_error": "Veuillez entrer un prix valide!",
        "add_new": "Ajouter nouveau",
        "note": "Remarque",
        "enter_note_here": "Saisir une remarque ici...",
        "subtotal": "Sous-total",
        "discount": "Remise",
        "gst": "TVA",
        "tax": "Taxe",
        "payable_amount": "Montant à payer",
        "igst": "TVA inter-état",
        "inoive_add_success_message": "Facture ajoutée avec succès!",
        "inoive_add_failed_message": "Échec de la création de la facture, veuillez réessayer!",
        "inoive_edit_success_message": "Facture mise à jour avec succès!",
        "inoive_edit_failed_message": "Échec de la mise à jour de la facture, veuillez réessayer!",
        "invoice_delete_success_message": "Facture supprimée avec succès!",
        "inoive_delete_failed_message": "Échec de la suppression de la facture, veuillez réessayer!",
        "inoive_delete_conformation_text": "Êtes-vous sûr de vouloir supprimer cette facture?",
        "inoive_delete_conformation": "Confirmer la suppression",
        "creation_Date": "Date de création",



        // Aperçu
        "to": "À",
        "billed_to": "Facturé à",
        "BILLED_TO": "FACTURÉ À",
        "BILL_TO": "FACTURÉ À",
        "date": "Date",
        "date_of_issue": "Date d'émission",
        "DATE_OF_ISSUE": "DATE D'ÉMISSION",
        "INVOICE": "FACTURE",
        "no": "N°",
        "invoice_number": "Numéro de facture",
        "INVOICE_NUMBER": "NUMÉRO DE FACTURE",
        "disc": "Remise",
        "signature_of": "Signature de",
        "terms": "Conditions",
        "receiver_signature": "Signature du destinataire",
        "INVOICE_TOTAL": "TOTAL DE LA FACTURE",
        "TAX_RATE": "TAUX DE TAXE",
        "TAX": "TAXE",
        "TOTAL": "TOTAL",

        // Client
        "customers_list": "Liste des clients",
        "search_customer": "Rechercher un client...",
        "phone": "Téléphone",
        "total_amount": "Montant total",
        "view_customer": "Voir le client",
        "name": "Nom",
        "GST": "TVA",
        "related_invoices": "Factures associées",

        // Ajouter/Modifier client
        "add_customer": "Ajouter un client",
        "edit_customer": "Modifier le client",
        "customer_name": "Nom du client",
        "email": "Email",
        "phone_number": "Numéro de téléphone",
        "gst_number": "Numéro de TVA",
        "address": "Adresse",
        "enter_customer_name": "Saisir le nom du client",
        "enter_email": "Saisir l'email",
        "enter_phone_number": "Saisir le numéro de téléphone",
        "enter_gst_number": "Saisir le numéro de TVA",
        "enter_address": "Saisir l'adresse",
        "customer_name_error": "Veuillez entrer un nom valide!",
        "customer_email_error": "Veuillez entrer un email valide!",
        "customer_phone_number_error": "Veuillez entrer un numéro valide!",
        "customer_edit_success_message": "Client mis à jour avec succès!",
        "customer_edit_failed_message": "Échec de la mise à jour du client, veuillez réessayer!",

        // Articles vendus - Liste
        "sold_items_list": "Liste des articles vendus",
        "search_item": "Rechercher un article...",
        "quantity": "Quantité",
        "total": "Total",

        // Dépense
        "expense_list": "Liste des dépenses",
        "Expense_Name": "Nom de la dépense",
        "Payment_Method": "Mode de paiement",
        "Add_expense": "Ajouter une dépense",
        "Search_expenses": "Rechercher des dépenses...",
        "Expense_Date": "Date de la dépense",
        "Expense_Category": "Catégorie de la dépense",
        "Enter_Expense_Name": "Saisir le nom",
        "Enter_Expense_Description": "Saisir la description",
        "Expense_add_success_message": "Dépense créée avec succès!",
        "Expense_add_failed_message": "Échec de la création de la dépense, veuillez réessayer!",
        "Expense_edit_success_message": "Dépense mise à jour avec succès!",
        "Expense_edit_failed_message": "Échec de la mise à jour de la dépense, veuillez réessayer!",
        "Expense_delete_success_message": "Dépense supprimée avec succès!",
        "Expense_delete_failed_message": "Échec de la suppression de la dépense, veuillez réessayer!",
        "Expense_delete_conformation_text": "Êtes-vous sûr de vouloir supprimer cette dépense?",
        "expense_edit": "Modifier la dépense",
        "delete": "Supprimer",


        "cash": "Espèces",
        "upi": "UPI",
        "cheque": "Chèque",
        "card": "Carte",
        "electronics": "Électronique",

        // Retour de vente
        "SaleReturn_List": "Liste des retours de vente",
        "SaleReturn_Search": "Rechercher un retour de vente...",
        "SaleReturn_add": "Ajouter un retour de vente",
        "SaleReturn_add_success_message": "Retour de vente créé avec succès!",
        "SaleReturn_add_failed_message": "Échec de la création du retour de vente, veuillez réessayer!",
        "SaleReturn_edit_success_message": "Retour de vente mis à jour avec succès!",
        "SaleReturn_edit_failed_message": "Échec de la mise à jour du retour de vente, veuillez réessayer!",
        "SaleReturn_delete_success_message": "Retour de vente supprimé avec succès!",
        "SaleReturn_delete_failed_message": "Échec de la suppression du retour de vente, veuillez réessayer!",
        "SaleReturn_delete_conformation_text": "Êtes-vous sûr de vouloir supprimer ce retour de vente?",
        "SaleReturn_edit": "Modifier le retour de vente",
        "SaleReturn_Reason": "Raison du retour de vente",
        "SaleReturn_Reason_enter": "Entrez une raison",
        "SaleReturn_Reason_note": "La facture de vente n'a pas été payée, donc aucune transaction n'aura lieu dans ce retour de vente.",


        // Filtres
        "today": "Aujourd'hui",
        "yesterday": "Hier",
        "last_7_days": "7 derniers jours",
        "this_month": "Ce mois-ci",
        "last_month": "Le mois dernier",
        "custome": "Personnalisé",

        // Jours
        "sunday": "Dimanche",
        "monday": "Lundi",
        "tuesday": "Mardi",
        "wednesday": "Mercredi",
        "thursday": "Jeudi",
        "friday": "Vendredi",
        "saturday": "Samedi",

        // Pays
        "Country_name": "Nom du pays",
        "Country_code": "Code du pays",
        "Country_symbol": "Symbole",
        "Country_flag": "Drapeau",
        "search_by": "Rechercher par pays ou code de devise"

    },
    "de": {
        // Seitenleiste
        "dashboard": "Dashboard",
        "business": "Geschäft",
        "invoice": "Rechnung",
        "customers": "Kunden",
        "sold_items": "Verkaufte Artikel",
        "expense": "Ausgaben",
        "currency": "Währung",
        "sale_return": "Rückgabe",
        "premium_access": "Premium-Zugang",
        "valid_until": "Gültig bis",

        // Allgemein
        "view_all": "Alle anzeigen",
        "back": "Zurück",
        "add": "Hinzufügen",
        "update": "Aktualisieren",
        "cancel": "Abbrechen",
        "save": "Speichern",
        "edit": "Bearbeiten",
        "print": "Drucken",
        "download": "Herunterladen",
        "All": "Alle",
        "email": "E-Mail",
        "All_Business": "Alle Geschäfte",
        "add_new": "Neu hinzufügen",
        "note": "Hinweis",
        "igst": "IGST",
        "price_error": "Bitte geben Sie einen gültigen Preis ein!",

        // Dashboard
        "bannerTitle": "Billnama – Verwalten Sie Ihre Rechnungen, Artikel und Kunden ganz einfach",
        "bannerDesc": "Verfolgen Sie Ihre täglichen Rechnungen einfach, verwalten Sie Artikel und führen Sie Kundenaufzeichnungen an einem Ort. Billnama optimiert Ihren Abrechnungsprozess, spart Zeit und hilft Ihnen, organisiert zu bleiben.",
        "create_new": "Neue Rechnung erstellen",
        "business_overview_Insights": "Geschäftsübersicht & Einblicke",
        "total_earning": "Gesamteinnahmen",
        "total_paid_earning": "Gesamte bezahlte Einnahmen",
        "total_unpaid_earning": "Gesamte unbezahlte Einnahmen",
        "total_business": "Gesamtzahl der Geschäfte",
        "total_invoices": "Gesamtzahl der Rechnungen",
        "total_customers": "Gesamtzahl der Kunden",
        "total_sold_items": "Gesamtzahl der verkauften Artikel",
        "recent_invoice": "Letzte Rechnungen",
        "recent_businesses": "Letzte Geschäfte",
        "paid_earning": "Bezahlte Einnahmen",
        "unpaid_earning": "Unbezahlte Einnahmen",
        "total_expense": "Gesamtausgaben",
        "total_salereturn": "Gesamte Rückgaben",
        "Total_Earnings_Expense": "Gesamte Einnahmen & Ausgaben",
        "Session": "Sitzung",
        "billing": "Zahlungshistorie",
        "Delete_My_Account": "Mein Konto löschen",
        "Log_Out": "Abmelden",
        "Log_In": "Anmelden",


        // Geschäft
        "business_list": "Geschäftsliste",
        "search_business": "Geschäft suchen...",
        "create_business": "Geschäft erstellen",
        "business_logo": "Geschäftslogo",
        "business_name": "Geschäftsname",
        "gst_number": "Umsatzsteuer-ID",
        "invoice": "Rechnung",
        "customers": "Kunden",
        "issued_date": "Ausstellungsdatum",
        "action": "Aktion",
        "entries_per_page": "Einträge pro Seite",

        // Geschäft anzeigen
        "view_business": "Geschäft anzeigen",
        "business_info": "Geschäftsinformationen",
        "address": "Adresse",
        "tc_account_details": "Geschäftsbedingungen / Kontodetails",

        // Geschäft hinzufügen/bearbeiten
        "add_business": "Geschäft hinzufügen",
        "edit_business": "Geschäft bearbeiten",
        "business_name_error": "Bitte geben Sie einen gültigen Geschäftsnamen ein!",
        "enter_business_name": "Geschäftsnamen eingeben",
        "enter_gst_number": "Umsatzsteuer-ID eingeben",
        "enter_address": "Adresse eingeben",
        "enter_tc_account_details": "Geschäftsbedingungen / Kontodetails eingeben",
        "business_add_success_message": "Geschäft erfolgreich erstellt!",
        "business_add_failed_message": "Fehler beim Erstellen des Geschäfts, bitte versuchen Sie es erneut!",
        "business_edit_success_message": "Geschäft erfolgreich aktualisiert!",
        "business_edit_failed_message": "Fehler beim Aktualisieren des Geschäfts, bitte versuchen Sie es erneut!",

        // Rechnung
        "invoice_list": "Rechnungsliste",
        "search_invoices": "Rechnung suchen...",
        "create_invoices": "Rechnung erstellen",
        "s_r": "Seriennummer",
        "invoice_no": "Rechnungsnummer",
        "customer_name": "Kundenname",
        "amount": "Betrag",
        "issued_date": "Ausstellungsdatum",
        "status": "Status",
        "action": "Aktion",
        "paid": "Bezahlt",
        "unpaid": "Unbezahlt",

        // Rechnung hinzufügen/bearbeiten
        "add_invoice": "Neue Rechnung erstellen",
        "edit_invoice": "Rechnung bearbeiten",
        "due_date": "Fälligkeitsdatum",
        "items": "Artikel",
        "description": "Beschreibung",
        "qty": "Menge",
        "hours": "Stunden",
        "price": "Preis",
        "total": "Gesamt",
        "enter_item": "Artikel eingeben",
        "enter_desc": "Beschreibung eingeben",
        "subtotal": "Zwischensumme",
        "discount": "Rabatt",
        "gst": "Umsatzsteuer",
        "tax": "Steuer",
        "payable_amount": "Zahlbarer Betrag",
        "creation_Date": "Erstellungsdatum",
        "invoice_delete_success_message": "Rechnung wurde erfolgreich gelöscht!",
        "inoive_delete_failed_message": "Löschen der Rechnung fehlgeschlagen, bitte versuchen Sie es erneut!",
        "inoive_delete_conformation_text": "Sind Sie sicher, dass Sie diese Rechnung löschen möchten?",
        "inoive_delete_conformation": "Löschen bestätigen",


        // Vorschau
        "to": "An",
        "billed_to": "Rechnung an",
        "date": "Datum",
        "invoice_number": "Rechnungsnummer",
        "signature_of": "Unterschrift von",
        "terms": "Bedingungen",
        "receiver_signature": "Unterschrift des Empfängers",

        // Kunden
        "customers_list": "Kundenliste",
        "search_customer": "Kunden suchen...",
        "phone": "Telefon",
        "total_amount": "Gesamtbetrag",
        "view_customer": "Kunden anzeigen",
        "name": "Name",
        "related_invoices": "Verwandte Rechnungen",

        // Kunde hinzufügen/bearbeiten
        "add_customer": "Kunde hinzufügen",
        "edit_customer": "Kunde bearbeiten",
        "customer_name": "Kundenname",
        "email": "E-Mail",
        "phone_number": "Telefonnummer",
        "address": "Adresse",
        "enter_customer_name": "Kundenname eingeben",
        "enter_email": "E-Mail eingeben",
        "enter_phone_number": "Telefonnummer eingeben",
        "enter_address": "Adresse eingeben",
        "customer_name_error": "Bitte geben Sie einen gültigen Namen ein!",

        // Verkaufte Artikel
        "sold_items_list": "Liste der verkauften Artikel",
        "search_item": "Artikel suchen...",
        "quantity": "Menge",
        "total": "Gesamt",

        // Ausgabenliste
        "expense_list": "Ausgaben - Liste",
        "Expense_Name": "Ausgabenname",
        "Payment_Method": "Zahlungsmethode",
        "Add_expense": "Ausgabe hinzufügen",
        "Search_expenses": "Ausgaben suchen...",
        "Expense_Date": "Ausgabendatum",
        "Expense_Category": "Ausgabenkategorie",
        "Enter_Expense_Name": "Namen eingeben",
        "Enter_Expense_Description": "Beschreibung eingeben",
        "Expense_add_success_message": "Dépense créée avec succès !",
        "Expense_add_failed_message": "Échec de la création de la dépense, veuillez réessayer !",
        "Expense_edit_success_message": "Dépense mise à jour avec succès !",
        "Expense_edit_failed_message": "Échec de la mise à jour de la dépense, veuillez réessayer !",
        "Expense_delete_success_message": "Dépense supprimée avec succès !",
        "Expense_delete_failed_message": "Échec de la suppression de la dépense, veuillez réessayer !",
        "Expense_delete_conformation_text": "Êtes-vous sûr de vouloir supprimer cette dépense ?",
        "expense_edit": "Modifier la dépense",
        "delete": "Supprimer",


        "cash": "Bargeld",
        "upi": "UPI",
        "cheque": "Scheck",
        "card": "Karte",
        "electronics": "Elektronik",

        // Verkaufsrückgabe
        "SaleReturn_List": "Verkaufsrückgabe - Liste",
        "SaleReturn_Search": "Verkaufsrückgabe suchen...",
        "SaleReturn_add": "Ajouter un retour de vente",
        "SaleReturn_add_success_message": "Retour de vente créé avec succès !",
        "SaleReturn_add_failed_message": "Échec de la création du retour de vente, veuillez réessayer !",
        "SaleReturn_edit_success_message": "Retour de vente mis à jour avec succès !",
        "SaleReturn_edit_failed_message": "Échec de la mise à jour du retour de vente, veuillez réessayer !",
        "SaleReturn_delete_success_message": "Retour de vente supprimé avec succès !",
        "SaleReturn_delete_failed_message": "Échec de la suppression du retour de vente, veuillez réessayer !",
        "SaleReturn_delete_conformation_text": "Êtes-vous sûr de vouloir supprimer ce retour de vente ?",
        "SaleReturn_edit": "Modifier le retour de vente",
        "SaleReturn_Reason": "Raison du retour de vente",
        "SaleReturn_Reason_enter": "Saisissez une raison",
        "SaleReturn_Reason_note": "La facture de vente n’a pas été payée, donc aucune transaction ne sera effectuée pour ce retour de vente.",


        // Filter
        "today": "Heute",
        "yesterday": "Gestern",
        "last_7_days": "Letzte 7 Tage",
        "this_month": "Diesen Monat",
        "last_month": "Letzten Monat",
        "custome": "Benutzerdefiniert",

        // Tage
        "sunday": "Sonntag",
        "monday": "Montag",
        "tuesday": "Dienstag",
        "wednesday": "Mittwoch",
        "thursday": "Donnerstag",
        "friday": "Freitag",
        "saturday": "Samstag",

        // Land
        "Country_name": "Ländername",
        "Country_code": "Ländercode",
        "Country_symbol": "Symbol",
        "Country_flag": "Flagge",
        "search_by": "Nach Land oder Währungscode suchen"

    },
    "nl": {
        // Zijbalk
        "dashboard": "Dashboard",
        "business": "Bedrijf",
        "invoice": "Factuur",
        "customers": "Klanten",
        "sold_items": "Verkochte artikelen",
        "expense": "Uitgave",
        "currency": "Valuta",
        "sale_return": "Verkoopretour",
        "premium_access": "Premium toegang",
        "valid_until": "Geldig tot",

        // Algemeen
        "view_all": "Alles bekijken",
        "back": "Terug",
        "add": "Toevoegen",
        "update": "Bijwerken",
        "cancel": "Annuleren",
        "save": "Opslaan",
        "edit": "Bewerken",
        "print": "Afdrukken",
        "download": "Downloaden",
        "All": "Alle",
        "email": "E-mail",
        "All_Business": "Alle bedrijven",

        // Dashboard
        "bannerTitle": "Billnama - Beheer eenvoudig uw facturen, artikelen en klanten",
        "bannerDesc": "Houd eenvoudig uw dagelijkse facturen bij, beheer artikelen en bewaar klantgegevens op één plek. Billnama stroomlijnt uw factureringsproces, bespaart tijd en helpt u georganiseerd te blijven.",
        "create_new": "Nieuwe factuur maken",
        "business_overview_Insights": "Bedrijfsinzichten en overzicht",
        "total_earning": "Totale inkomsten",
        "total_paid_earning": "Totaal betaalde inkomsten",
        "total_unpaid_earning": "Totaal openstaande inkomsten",
        "total_business": "Totaal aantal bedrijven",
        "total_invoices": "Totaal aantal facturen",
        "total_customers": "Totaal aantal klanten",
        "total_sold_items": "Totaal verkochte artikelen",
        "recent_invoice": "Recente factuur",
        "recent_businesses": "Recente bedrijven",
        "paid_earning": "Betaalde inkomsten",
        "unpaid_earning": "Openstaande inkomsten",
        "total_expense": "Totale uitgaven",
        "total_salereturn": "Totale verkoopretour",
        "Total_Earnings_Expense": "Totale inkomsten en uitgaven",
        "Session": "Sessie",
        "billing": "Betalingsgeschiedenis",
        "Delete_My_Account": "Mijn account verwijderen",
        "Log_Out": "Uitloggen",
        "Log_In": "Inloggen",


        // Bedrijf
        "business_list": "Bedrijven - Lijst",
        "search_business": "Zoek bedrijf...",
        "create_business": "Bedrijf aanmaken",
        "business_logo": "Bedrijfslogo",
        "business_name": "Bedrijfsnaam",
        "gst_number": "BTW-nummer",
        "invoice": "Factuur",
        "customers": "Klanten",
        "issued_date": "Uitgiftedatum",
        "action": "Actie",
        "entries_per_page": "Invoeren per pagina",

        // Bedrijf bekijken
        "view_business": "Bekijk bedrijf",
        "business_info": "Bedrijfsinformatie",
        "address": "Adres",
        "tc_account_details": "Voorwaarden / Accountgegevens",

        // Bedrijf toevoegen/bewerken
        "add_business": "Bedrijf toevoegen",
        "edit_business": "Bedrijf bewerken",
        "business_name_error": "Voer een geldige bedrijfsnaam in!",
        "enter_business_name": "Voer bedrijfsnaam in",
        "enter_gst_number": "Voer BTW-nummer in",
        "enter_address": "Voer adres in",
        "enter_tc_account_details": "Voer voorwaarden / accountgegevens in",
        "business_add_success_message": "Bedrijf succesvol aangemaakt!",
        "business_add_failed_message": "Fout bij aanmaken van bedrijf, probeer opnieuw!",
        "business_edit_success_message": "Bedrijf succesvol bijgewerkt!",
        "business_edit_failed_message": "Fout bij bijwerken van bedrijf, probeer opnieuw!",

        // Factuur
        "invoice_list": "Facturen - Lijst",
        "search_invoices": "Zoek facturen...",
        "create_invoices": "Factuur aanmaken",
        "s_r": "Nr.",
        "invoice_no": "Factuurnummer",
        "customer_name": "Klantnaam",
        "amount": "Bedrag",
        "issued_date": "Uitgiftedatum",
        "status": "Status",
        "action": "Actie",
        "paid": "Betaald",
        "unpaid": "Onbetaald",

        // Factuur toevoegen/bewerken
        "add_invoice": "Nieuwe factuur maken",
        "edit_invoice": "Factuur bewerken",
        "due_date": "Vervaldatum",
        "items": "Artikelen",
        "description": "Beschrijving",
        "qty": "Aantal",
        "hours": "Uren",
        "price": "Prijs",
        "total": "Totaal",
        "enter_item": "Voer artikel in",
        "enter_desc": "Voer beschrijving in",
        "item_error": "Voer een geldig artikel in!",
        "qty_error": "Voer een geldig aantal in!",
        "price_error": "Voer een geldige prijs in!",
        "add_new": "Nieuw toevoegen",
        "note": "Opmerking",
        "enter_note_here": "Voer hier een opmerking in...",
        "subtotal": "Subtotaal",
        "discount": "Korting",
        "gst": "BTW",
        "tax": "Belasting",
        "payable_amount": "Te betalen bedrag",
        "igst": "IGST",
        "invoice_add_success_message": "Factuur succesvol toegevoegd!",
        "invoice_add_failed_message": "Fout bij aanmaken van factuur, probeer opnieuw!",
        "invoice_edit_success_message": "Factuur succesvol bijgewerkt!",
        "invoice_edit_failed_message": "Fout bij bijwerken van factuur, probeer opnieuw!",

        "creation_date": "Aanmaakdatum",
        "invoice_delete_success_message": "Factuur succesvol verwijderd!",
        "inoive_delete_failed_message": "Kan de factuur niet verwijderen, probeer het alstublieft opnieuw!",
        "inoive_delete_conformation_text": "Weet u zeker dat u deze factuur wilt verwijderen?",
        "inoive_delete_conformation": "Verwijdering Bevestigen",

        // Klanten
        "customers_list": "Klanten - Lijst",
        "search_customer": "Zoek klanten...",
        "phone": "Telefoon",
        "total_amount": "Totaalbedrag",
        "view_customer": "Bekijk klant",
        "name": "Naam",
        "GST": "BTW",
        "related_invoices": "Gerelateerde facturen",

        // Klant toevoegen/bewerken
        "add_customer": "Klant toevoegen",
        "edit_customer": "Klant bewerken",
        "customer_name": "Klantnaam",
        "email": "E-mail",
        "phone_number": "Telefoonnummer",
        "gst_number": "BTW-nummer",
        "address": "Adres",
        "enter_customer_name": "Voer klantnaam in",
        "enter_email": "Voer e-mail in",
        "enter_phone_number": "Voer telefoonnummer in",
        "enter_gst_number": "Voer BTW-nummer in",
        "enter_address": "Voer adres in",
        "customer_name_error": "Voer een geldige naam in!",
        "customer_email_error": "Voer een geldig e-mailadres in!",
        "customer_phone_number_error": "Voer een geldig telefoonnummer in!",
        "customer_edit_success_message": "Klant succesvol bijgewerkt!",
        "customer_edit_failed_message": "Fout bij bijwerken van klant, probeer opnieuw!",

        // Verkochte items
        "sold_items_list": "Verkochte items - Lijst",
        "search_item": "Zoek artikelen...",
        "quantity": "Aantal",
        "total": "Totaal",

        // Uitgavenlijst
        "expense_list": "Uitgaven - Lijst",
        "Expense_Name": "Naam van uitgave",
        "Payment_Method": "Betaalmethode",
        "Add_expense": "Uitgave toevoegen",
        "Search_expenses": "Uitgaven zoeken...",
        "Expense_Date": "Uitgavedatum",
        "Expense_Category": "Uitgavecategorie",
        "Enter_Expense_Name": "Voer naam in",
        "Enter_Expense_Description": "Voer beschrijving in",

        "Expense_add_success_message": "Uitgave succesvol aangemaakt!",
        "Expense_add_failed_message": "Kan de uitgave niet aanmaken, probeer het alstublieft opnieuw!",
        "Expense_edit_success_message": "Uitgave succesvol bijgewerkt!",
        "Expense_edit_failed_message": "Kan de uitgave niet bijwerken, probeer het alstublieft opnieuw!",
        "Expense_delete_success_message": "Uitgave succesvol verwijderd!",
        "Expense_delete_failed_message": "Kan de uitgave niet verwijderen, probeer het alstublieft opnieuw!",
        "Expense_delete_conformation_text": "Weet u zeker dat u deze uitgave wilt verwijderen?",
        "expense_edit": "Bewerk uitgave",
        "delete": "Verwijderen",



        "cash": "Contant",
        "upi": "UPI",
        "cheque": "Cheque",
        "card": "Kaart",
        "electronics": "Elektronica",

        // Verkoopretour
        "SaleReturn_List": "Verkoopretour - Lijst",
        "SaleReturn_Search": "Zoek verkoopretour...",
        "SaleReturn_add": "Verkoopretour Toevoegen",
        "SaleReturn_add_success_message": "Verkoopretour succesvol aangemaakt!",
        "SaleReturn_add_failed_message": "Kan de verkoopretour niet aanmaken, probeer het alstublieft opnieuw!",
        "SaleReturn_edit_success_message": "Verkoopretour succesvol bijgewerkt!",
        "SaleReturn_edit_failed_message": "Kan de verkoopretour niet bijwerken, probeer het alstublieft opnieuw!",
        "SaleReturn_delete_success_message": "Verkoopretour succesvol verwijderd!",
        "SaleReturn_delete_failed_message": "Kan de verkoopretour niet verwijderen, probeer het alstublieft opnieuw!",
        "SaleReturn_delete_conformation_text": "Weet u zeker dat u deze verkoopretour wilt verwijderen?",
        "SaleReturn_edit": "Bewerk Verkoopretour",
        "SaleReturn_Reason": "Reden van Verkoopretour",
        "SaleReturn_Reason_enter": "Voer een reden in",
        "SaleReturn_Reason_note": "De verkoopfactuur is niet betaald, dus er zal geen transactie plaatsvinden bij deze retour.",


        // Filters
        "today": "Vandaag",
        "yesterday": "Gisteren",
        "last_7_days": "Laatste 7 dagen",
        "this_month": "Deze maand",
        "last_month": "Vorige maand",
        "custome": "Aangepast",

        // Dagen
        "sunday": "Zondag",
        "monday": "Maandag",
        "tuesday": "Dinsdag",
        "wednesday": "Woensdag",
        "thursday": "Donderdag",
        "friday": "Vrijdag",
        "saturday": "Zaterdag",

        // Land
        "Country_name": "Landnaam",
        "Country_code": "Landcode",
        "Country_symbol": "Symbool",
        "Country_flag": "Vlag",
        "search_by": "Zoek op land of valutacode"

    },
    "es": {
        // Barra lateral
        "dashboard": "Tablero",
        "business": "Negocio",
        "invoice": "Factura",
        "customers": "Clientes",
        "sold_items": "Artículos vendidos",
        "expense": "Gasto",
        "currency": "Moneda",
        "sale_return": "Devolución de venta",
        "premium_access": "Acceso premium",
        "valid_until": "Válido hasta",

        // General
        "view_all": "Ver todo",
        "back": "Atrás",
        "add": "Agregar",
        "update": "Actualizar",
        "cancel": "Cancelar",
        "save": "Guardar",
        "edit": "Editar",
        "print": "Imprimir",
        "download": "Descargar",
        "All": "Todos",
        "email": "Correo electrónico",
        "All_Business": "Todos los negocios",

        // Tablero
        "bannerTitle": "Billnama - Administra fácilmente tus facturas, artículos y clientes",
        "bannerDesc": "Haz un seguimiento fácil de tus facturas diarias, gestiona artículos y mantén los registros de clientes en un solo lugar. Billnama simplifica tu proceso de facturación, ahorra tiempo y te ayuda a mantener el control.",
        "create_new": "Crear nueva factura",
        "business_overview_Insights": "Resumen y perspectivas del negocio",
        "total_earning": "Ganancias totales",
        "total_paid_earning": "Ganancias pagadas totales",
        "total_unpaid_earning": "Ganancias pendientes totales",
        "total_business": "Total de negocios",
        "total_invoices": "Total de facturas",
        "total_customers": "Total de clientes",
        "total_sold_items": "Total de artículos vendidos",
        "recent_invoice": "Factura reciente",
        "recent_businesses": "Negocios recientes",
        "paid_earning": "Ganancias pagadas",
        "unpaid_earning": "Ganancias pendientes",
        "total_expense": "Gastos totales",
        "total_salereturn": "Total de devoluciones de venta",
        "Total_Earnings_Expense": "Ingresos y gastos totales",
        "Session": "Sesión",
        "billing": "Historial de pagos",
        "Delete_My_Account": "Eliminar mi cuenta",
        "Log_Out": "Cerrar sesión",
        "Log_In": "Iniciar sesión",


        // Negocio
        "business_list": "Lista de negocios",
        "search_business": "Buscar negocio...",
        "create_business": "Crear negocio",
        "business_logo": "Logo del negocio",
        "business_name": "Nombre del negocio",
        "gst_number": "Número de IVA",
        "invoice": "Factura",
        "customers": "Clientes",
        "issued_date": "Fecha de emisión",
        "action": "Acción",
        "entries_per_page": "Entradas por página",

        // Ver negocio
        "view_business": "Ver negocio",
        "business_info": "Información del negocio",
        "address": "Dirección",
        "tc_account_details": "Términos y condiciones / Detalles de cuenta",

        // Agregar/Editar negocio
        "add_business": "Agregar negocio",
        "edit_business": "Editar negocio",
        "business_name_error": "¡Por favor, ingrese un nombre de negocio válido!",
        "enter_business_name": "Ingrese el nombre del negocio",
        "enter_gst_number": "Ingrese el número de IVA",
        "enter_address": "Ingrese la dirección",
        "enter_tc_account_details": "Ingrese los términos y condiciones / Detalles de cuenta",
        "business_add_success_message": "¡Negocio creado con éxito!",
        "business_add_failed_message": "Error al crear el negocio, ¡inténtelo de nuevo!",
        "business_edit_success_message": "¡Negocio actualizado con éxito!",
        "business_edit_failed_message": "Error al actualizar el negocio, ¡inténtelo de nuevo!",

        // Factura
        "invoice_list": "Lista de facturas",
        "search_invoices": "Buscar facturas...",
        "create_invoices": "Crear factura",
        "s_r": "N° de serie",
        "invoice_no": "Número de factura",
        "customer_name": "Nombre del cliente",
        "amount": "Monto",
        "issued_date": "Fecha de emisión",
        "status": "Estado",
        "action": "Acción",
        "paid": "Pagado",
        "unpaid": "Pendiente",

        // Agregar/Editar factura
        "add_invoice": "Crear nueva factura",
        "edit_invoice": "Editar factura",
        "due_date": "Fecha de vencimiento",
        "items": "Artículos",
        "description": "Descripción",
        "qty": "Cantidad",
        "hours": "Horas",
        "price": "Precio",
        "total": "Total",
        "action": "Acción",
        "enter_item": "Ingrese un artículo",
        "enter_desc": "Ingrese una descripción",
        "item_error": "¡Ingrese un artículo válido!",
        "qty_error": "¡Ingrese una cantidad válida!",
        "price_error": "¡Ingrese un precio válido!",
        "add_new": "Agregar nuevo",
        "note": "Nota",
        "enter_note_here": "Ingrese una nota aquí...",
        "subtotal": "Subtotal",
        "discount": "Descuento",
        "gst": "IVA",
        "tax": "Impuesto",
        "payable_amount": "Monto a pagar",
        "igst": "IVA interregional",
        "invoice_add_success_message": "¡Factura agregada con éxito!",
        "invoice_add_failed_message": "Error al crear la factura, ¡inténtelo de nuevo!",
        "invoice_edit_success_message": "¡Factura actualizada con éxito!",
        "invoice_edit_failed_message": "Error al actualizar la factura, ¡inténtelo de nuevo!",
        "SaleReturn_add": "Agregar devolución de venta",
        "SaleReturn_add_success_message": "¡Devolución de venta creada con éxito!",
        "SaleReturn_add_failed_message": "No se pudo crear la devolución de venta. ¡Inténtalo de nuevo!",
        "SaleReturn_edit_success_message": "¡Devolución de venta actualizada con éxito!",
        "SaleReturn_edit_failed_message": "No se pudo actualizar la devolución de venta. ¡Inténtalo de nuevo!",
        "SaleReturn_delete_success_message": "¡Devolución de venta eliminada con éxito!",
        "SaleReturn_delete_failed_message": "No se pudo eliminar la devolución de venta. ¡Inténtalo de nuevo!",
        "SaleReturn_delete_conformation_text": "¿Está seguro de que desea eliminar esta devolución de venta?",
        "SaleReturn_edit": "Editar devolución de venta",
        "SaleReturn_Reason": "Motivo de la devolución de venta",
        "SaleReturn_Reason_enter": "Ingrese un motivo",
        "SaleReturn_Reason_note": "La factura de venta no fue pagada, por lo tanto no se realizará ninguna transacción en esta devolución de venta.",

        // Vista previa
        "to": "Para",
        "billed_to": "Facturado a",
        "BILLED_TO": "FACTURADO A",
        "BILL_TO": "FACTURADO A",
        "date": "Fecha",
        "date_of_issue": "Fecha de emisión",
        "DATE_OF_ISSUE": "FECHA DE EMISIÓN",
        "INVOICE": "FACTURA",
        "no": "N°",
        "invoice_number": "Número de factura",
        "INVOICE_NUMBER": "NÚMERO DE FACTURA",
        "disc": "Descuento",
        "signature_of": "Firma de",
        "terms": "Términos",
        "receiver_signature": "Firma del receptor",
        "INVOICE_TOTAL": "TOTAL DE LA FACTURA",
        "TAX_RATE": "TASA DE IMPUESTO",
        "TAX": "IMPUESTO",
        "TOTAL": "TOTAL",

        // Cliente
        "customers_list": "Lista de clientes",
        "search_customer": "Buscar cliente...",
        "phone": "Teléfono",
        "total_amount": "Monto total",
        "view_customer": "Ver cliente",
        "name": "Nombre",
        "GST": "IVA",
        "related_invoices": "Facturas relacionadas",

        // Agregar/Editar cliente
        "add_customer": "Agregar cliente",
        "edit_customer": "Editar cliente",
        "customer_name": "Nombre del cliente",
        "email": "Correo electrónico",
        "phone_number": "Número de teléfono",
        "gst_number": "Número de IVA",
        "address": "Dirección",
        "enter_customer_name": "Ingrese el nombre del cliente",
        "enter_email": "Ingrese el correo electrónico",
        "enter_phone_number": "Ingrese el número de teléfono",
        "enter_gst_number": "Ingrese el número de IVA",
        "enter_address": "Ingrese la dirección",
        "customer_name_error": "¡Ingrese un nombre válido!",
        // Lista de gastos
        "expense_list": "Lista de gastos",
        "Expense_Name": "Nombre del gasto",
        "Payment_Method": "Método de pago",
        "Add_expense": "Agregar gasto",
        "Search_expenses": "Buscar gastos...",
        "Expense_Date": "Fecha del gasto",
        "Expense_Category": "Categoría de gasto",
        "Enter_Expense_Name": "Ingrese el nombre",
        "Enter_Expense_Description": "Ingrese la descripción",
        "Expense_add_success_message": "¡Gasto creado con éxito!",
        "Expense_add_failed_message": "No se pudo crear el gasto. ¡Inténtalo de nuevo!",
        "Expense_edit_success_message": "¡Gasto actualizado con éxito!",
        "Expense_edit_failed_message": "No se pudo actualizar el gasto. ¡Inténtalo de nuevo!",
        "Expense_delete_success_message": "¡Gasto eliminado con éxito!",
        "Expense_delete_failed_message": "No se pudo eliminar el gasto. ¡Inténtalo de nuevo!",
        "Expense_delete_conformation_text": "¿Está seguro de que desea eliminar este gasto?",
        "expense_edit": "Editar gasto",
        "delete": "Eliminar",

        "cash": "Efectivo",
        "upi": "UPI",
        "cheque": "Cheque",
        "card": "Tarjeta",
        "electronics": "Electrónica",

        // Devolución de venta
        "SaleReturn_List": "Lista de devoluciones de venta",
        "SaleReturn_Search": "Buscar devoluciones de venta...",
        "SaleReturn_add": "Agregar devolución de venta",
        "SaleReturn_add_success_message": "¡Devolución de venta creada con éxito!",
        "SaleReturn_add_failed_message": "No se pudo crear la devolución de venta. ¡Inténtalo de nuevo!",
        "SaleReturn_edit_success_message": "¡Devolución de venta actualizada con éxito!",
        "SaleReturn_edit_failed_message": "No se pudo actualizar la devolución de venta. ¡Inténtalo de nuevo!",
        "SaleReturn_delete_success_message": "¡Devolución de venta eliminada con éxito!",
        "SaleReturn_delete_failed_message": "No se pudo eliminar la devolución de venta. ¡Inténtalo de nuevo!",
        "SaleReturn_delete_conformation_text": "¿Está seguro de que desea eliminar esta devolución de venta?",
        "SaleReturn_edit": "Editar devolución de venta",
        "SaleReturn_Reason": "Motivo de la devolución de venta",
        "SaleReturn_Reason_enter": "Ingrese un motivo",
        "SaleReturn_Reason_note": "La factura de venta no fue pagada, por lo tanto no se realizará ninguna transacción en esta devolución de venta.",


        // Filtros
        "today": "Hoy",
        "yesterday": "Ayer",
        "last_7_days": "Últimos 7 días",
        "this_month": "Este mes",
        "last_month": "Mes pasado",
        "custome": "Personalizado",

        // Días
        "sunday": "Domingo",
        "monday": "Lunes",
        "tuesday": "Martes",
        "wednesday": "Miércoles",
        "thursday": "Jueves",
        "friday": "Viernes",
        "saturday": "Sábado",

        // País
        "Country_name": "Nombre del país",
        "Country_code": "Código del país",
        "Country_symbol": "Símbolo",
        "Country_flag": "Bandera",
        "search_by": "Buscar por país o código de moneda"

    },
    "it": {
        // Barra laterale
        "dashboard": "Dashboard",
        "business": "Attività",
        "invoice": "Fattura",
        "customers": "Clienti",
        "sold_items": "Articoli venduti",
        "expense": "Spesa",
        "currency": "Valuta",
        "sale_return": "Reso di vendita",
        "premium_access": "Accesso Premium",
        "valid_until": "Valido fino a",

        // Generale
        "view_all": "Vedi tutto",
        "back": "Indietro",
        "add": "Aggiungi",
        "update": "Aggiorna",
        "cancel": "Annulla",
        "save": "Salva",
        "edit": "Modifica",
        "print": "Stampa",
        "download": "Scarica",
        "All": "Tutti",
        "email": "Email",
        "All_Business": "Tutte le attività",

        // Dashboard
        "bannerTitle": "Billnama - Gestisci facilmente le tue fatture, articoli e clienti",
        "bannerDesc": "Tieni traccia facilmente delle tue fatture quotidiane, gestisci gli articoli e conserva i dati dei clienti in un unico posto. Billnama semplifica il tuo processo di fatturazione, fa risparmiare tempo e ti aiuta a rimanere organizzato.",
        "create_new": "Crea nuova fattura",
        "business_overview_Insights": "Panoramica aziendale e approfondimenti",
        "total_earning": "Guadagni totali",
        "total_paid_earning": "Guadagni totali pagati",
        "total_unpaid_earning": "Guadagni totali non pagati",
        "total_business": "Totale attività",
        "total_invoices": "Totale fatture",
        "total_customers": "Totale clienti",
        "total_sold_items": "Totale articoli venduti",
        "recent_invoice": "Fatture recenti",
        "recent_businesses": "Attività recenti",
        "paid_earning": "Guadagni pagati",
        "unpaid_earning": "Guadagni non pagati",
        "total_expense": "Spese totali",
        "total_salereturn": "Totale resi di vendita",
        "Total_Earnings_Expense": "Guadagni e spese totali",
        "Session": "Sessione",
        "billing": "Storico pagamenti",
        "Delete_My_Account": "Elimina il mio account",
        "Log_Out": "Disconnetti",
        "Log_In": "Accedi",

        // Attività
        "business_list": "Elenco attività",
        "search_business": "Cerca attività...",
        "create_business": "Crea attività",
        "business_logo": "Logo attività",
        "business_name": "Nome attività",
        "gst_number": "Partita IVA",
        "invoice": "Fattura",
        "customers": "Clienti",
        "issued_date": "Data di emissione",
        "action": "Azione",
        "entries_per_page": "Voci per pagina",

        // Visualizza attività
        "view_business": "Visualizza attività",
        "business_info": "Informazioni sull'attività",
        "address": "Indirizzo",
        "tc_account_details": "Termini e condizioni / Dettagli conto",

        // Aggiungi/Modifica attività
        "add_business": "Aggiungi attività",
        "edit_business": "Modifica attività",
        "business_name_error": "Inserisci un nome attività valido!",
        "enter_business_name": "Inserisci nome attività",
        "enter_gst_number": "Inserisci partita IVA",
        "enter_address": "Inserisci indirizzo",
        "enter_tc_account_details": "Inserisci termini e condizioni / dettagli conto",
        "business_add_success_message": "Attività creata con successo!",
        "business_add_failed_message": "Creazione attività fallita, riprova!",
        "business_edit_success_message": "Attività aggiornata con successo!",
        "business_edit_failed_message": "Aggiornamento attività fallito, riprova!",

        // Fattura
        "invoice_list": "Elenco fatture",
        "search_invoices": "Cerca fatture...",
        "create_invoices": "Crea fattura",
        "s_r": "N°",
        "invoice_no": "Numero fattura",
        "customer_name": "Nome cliente",
        "amount": "Importo",
        "issued_date": "Data di emissione",
        "status": "Stato",
        "action": "Azione",
        "paid": "Pagata",
        "unpaid": "Non pagata",

        // Aggiungi/Modifica fattura
        "add_invoice": "Crea nuova fattura",
        "edit_invoice": "Modifica fattura",
        "due_date": "Data di scadenza",
        "items": "Articoli",
        "description": "Descrizione",
        "qty": "Quantità",
        "hours": "Ore",
        "price": "Prezzo",
        "total": "Totale",
        "action": "Azione",
        "enter_item": "Inserisci articolo",
        "enter_desc": "Inserisci descrizione",
        "item_error": "Inserisci un articolo valido!",
        "qty_error": "Inserisci una quantità valida!",
        "price_error": "Inserisci un prezzo valido!",
        "add_new": "Aggiungi nuovo",
        "note": "Nota",
        "enter_note_here": "Inserisci nota qui...",
        "subtotal": "Subtotale",
        "discount": "Sconto",
        "gst": "IVA",
        "tax": "Tassa",
        "payable_amount": "Importo da pagare",
        "igst": "IVA interstatale",
        "inoive_add_success_message": "Fattura aggiunta con successo!",
        "inoive_add_failed_message": "Creazione fattura fallita, riprova!",
        "inoive_edit_success_message": "Fattura aggiornata con successo!",
        "inoive_edit_failed_message": "Aggiornamento fattura fallito, riprova!",
        "creation_date": "Data di Creazione",
        "invoice_delete_success_message": "Fattura eliminata con successo!",
        "inoive_delete_failed_message": "Impossibile eliminare la fattura. Riprova!",
        "inoive_delete_conformation_text": "Sei sicuro di voler eliminare questa fattura?",
        "inoive_delete_conformation": "Conferma Eliminazione",

        // Anteprima
        "to": "A",
        "billed_to": "Fatturato a",
        "BILLED_TO": "FATTURATO A",
        "BILL_TO": "FATTURATO A",
        "date": "Data",
        "date_of_issue": "Data di emissione",
        "DATE_OF_ISSUE": "DATA DI EMISSIONE",
        "INVOICE": "FATTURA",
        "no": "N°",
        "invoice_number": "Numero fattura",
        "INVOICE_NUMBER": "NUMERO FATTURA",
        "disc": "Sconto",
        "signature_of": "Firma di",
        "terms": "Termini",
        "receiver_signature": "Firma del destinatario",
        "INVOICE_TOTAL": "TOTALE FATTURA",
        "TAX_RATE": "ALIQUOTA FISCALE",
        "TAX": "TASSA",
        "TOTAL": "TOTALE",

        // Clienti
        "customers_list": "Elenco clienti",
        "search_customer": "Cerca cliente...",
        "phone": "Telefono",
        "total_amount": "Importo totale",
        "view_customer": "Visualizza cliente",
        "name": "Nome",
        "GST": "IVA",
        "related_invoices": "Fatture correlate",

        // Aggiungi/Modifica cliente
        "add_customer": "Aggiungi cliente",
        "edit_customer": "Modifica cliente",
        "customer_name": "Nome cliente",
        "email": "Email",
        "phone_number": "Numero di telefono",
        "gst_number": "Partita IVA",
        "address": "Indirizzo",
        "enter_customer_name": "Inserisci nome cliente",
        "enter_email": "Inserisci email",
        "enter_phone_number": "Inserisci numero di telefono",
        "enter_gst_number": "Inserisci partita IVA",
        "enter_address": "Inserisci indirizzo",

        // Elenco delle spese
        "expense_list": "Elenco delle spese",
        "Expense_Name": "Nome della spesa",
        "Payment_Method": "Metodo di pagamento",
        "Add_expense": "Aggiungi spesa",
        "Search_expenses": "Cerca spese...",
        "Expense_Date": "Data della spesa",
        "Expense_Category": "Categoria di spesa",
        "Enter_Expense_Name": "Inserisci il nome",
        "Enter_Expense_Description": "Inserisci la descrizione",
        "Expense_add_success_message": "Spesa creata con successo!",
        "Expense_add_failed_message": "Impossibile creare la spesa. Riprova!",
        "Expense_edit_success_message": "Spesa aggiornata con successo!",
        "Expense_edit_failed_message": "Impossibile aggiornare la spesa. Riprova!",
        "Expense_delete_success_message": "Spesa eliminata con successo!",
        "Expense_delete_failed_message": "Impossibile eliminare la spesa. Riprova!",
        "Expense_delete_conformation_text": "Sei sicuro di voler eliminare questa spesa?",
        "expense_edit": "Modifica spesa",
        "delete": "Elimina",

        "cash": "Contanti",
        "upi": "UPI",
        "cheque": "Assegno",
        "card": "Carta",
        "electronics": "Elettronica",

        // Reso di vendita
        "SaleReturn_List": "Elenco dei resi di vendita",
        "SaleReturn_Search": "Cerca resi di vendita...",
        "SaleReturn_add": "Aggiungi Reso di Vendita",
        "SaleReturn_add_success_message": "Reso di vendita creato con successo!",
        "SaleReturn_add_failed_message": "Impossibile creare il reso di vendita. Riprova!",
        "SaleReturn_edit_success_message": "Reso di vendita aggiornato con successo!",
        "SaleReturn_edit_failed_message": "Impossibile aggiornare il reso di vendita. Riprova!",
        "SaleReturn_delete_success_message": "Reso di vendita eliminato con successo!",
        "SaleReturn_delete_failed_message": "Impossibile eliminare il reso di vendita. Riprova!",
        "SaleReturn_delete_conformation_text": "Sei sicuro di voler eliminare questo reso di vendita?",
        "SaleReturn_edit": "Modifica Reso di Vendita",
        "SaleReturn_Reason": "Motivo del Reso di Vendita",
        "SaleReturn_Reason_enter": "Inserisci un motivo",
        "SaleReturn_Reason_note": "La fattura di vendita non è stata pagata, quindi non verrà effettuata alcuna transazione per questo reso di vendita.",

        // Filtri
        "today": "Oggi",
        "yesterday": "Ieri",
        "last_7_days": "Ultimi 7 giorni",
        "this_month": "Questo mese",
        "last_month": "Mese scorso",
        "custome": "Personalizzato",

        // Giorni
        "sunday": "Domenica",
        "monday": "Lunedì",
        "tuesday": "Martedì",
        "wednesday": "Mercoledì",
        "thursday": "Giovedì",
        "friday": "Venerdì",
        "saturday": "Sabato",

        // Paese
        "Country_name": "Nome del paese",
        "Country_code": "Codice del paese",
        "Country_symbol": "Simbolo",
        "Country_flag": "Bandiera",
        "search_by": "Cerca per paese o codice valuta",

    },
    "ja": {
        // サイドバー
        "dashboard": "ダッシュボード",
        "business": "ビジネス",
        "invoice": "請求書",
        "customers": "顧客",
        "sold_items": "販売商品",
        "expense": "費用",
        "currency": "通貨",
        "sale_return": "売上返品",
        "premium_access": "プレミアムアクセス",
        "valid_until": "有効期限",

        // 一般
        "view_all": "すべて表示",
        "back": "戻る",
        "add": "追加",
        "update": "更新",
        "cancel": "キャンセル",
        "save": "保存",
        "edit": "編集",
        "print": "印刷",
        "download": "ダウンロード",
        "All": "すべて",
        "All_Business": "すべてのビジネス",

        // ダッシュボード
        "bannerTitle": "ビルナマ - 請求書、商品、顧客を簡単に管理",
        "bannerDesc": "日々の請求書を簡単に追跡し、商品を管理し、顧客記録を一箇所に保存できます。ビルナマは請求プロセスを合理化し、時間を節約し、整理整頓をサポートします。",
        "create_new": "新しい請求書を作成",
        "business_overview_Insights": "ビジネス概要と分析",
        "total_earning": "総収益",
        "total_paid_earning": "総支払い収益",
        "total_unpaid_earning": "総未払い収益",
        "total_business": "総ビジネス数",
        "total_invoices": "総請求書数",
        "total_customers": "総顧客数",
        "total_sold_items": "総販売商品数",
        "recent_invoice": "最近の請求書",
        "recent_businesses": "最近のビジネス",
        "paid_earning": "支払い済み収益",
        "unpaid_earning": "未払い収益",
        "total_expense": "総費用",
        "total_salereturn": "総売上返品",
        "Total_Earnings_Expense": "総収益と費用",
        "Session": "セッション",
        "billing": "支払い履歴",
        "Delete_My_Account": "アカウントを削除",
        "Log_Out": "ログアウト",

        // ビジネス
        "business_list": "ビジネス - 一覧",
        "search_business": "ビジネスを検索...",
        "create_business": "ビジネスを作成",
        "business_logo": "ビジネスロゴ",
        "business_name": "ビジネス名",
        "gst_number": "GST番号",
        "invoice": "請求書",
        "customers": "顧客",
        "issued_date": "発行日",
        "action": "アクション",
        "entries_per_page": "ページごとのエントリー数",

        // ビジネスの詳細
        "view_business": "ビジネスを表示",
        "business_info": "ビジネス情報",
        "address": "住所",
        "tc_account_details": "利用規約 / アカウント詳細",

        // ビジネスの追加/編集
        "add_business": "新しいビジネスを作成",
        "edit_business": "ビジネスを編集",
        "business_name_error": "有効なビジネス名を入力してください！",
        "enter_business_name": "ビジネス名を入力",
        "enter_gst_number": "GST番号を入力",
        "enter_address": "住所を入力",
        "enter_tc_account_details": "利用規約 / アカウント詳細を入力",
        "business_add_success_message": "ビジネスが正常に作成されました！",
        "business_add_failed_message": "ビジネスの作成に失敗しました。もう一度お試しください！",

        // 請求書
        "invoice_list": "請求書 - 一覧",
        "search_invoices": "請求書を検索...",
        "create_invoices": "請求書を作成",
        "invoice_no": "請求書番号",
        "customer_name": "顧客名",
        "amount": "金額",
        "issued_date": "発行日",
        "status": "ステータス",
        "paid": "支払い済み",
        "unpaid": "未払い",

        // 顧客
        "customers_list": "顧客 - 一覧",
        "search_customer": "顧客を検索...",
        "phone": "電話番号",
        "total_amount": "総金額",
        "view_customer": "顧客を表示",
        "name": "名前",
        "GST": "GST",
        "related_invoices": "関連する請求書",
        "creation_date": "作成日",
        "invoice_delete_success_message": "請求書が正常に削除されました！",
        "inoive_delete_failed_message": "請求書の削除に失敗しました。もう一度お試しください！",
        "inoive_delete_conformation_text": "この請求書を削除してもよろしいですか？",
        "inoive_delete_conformation": "削除の確認",

        // 売上返品
        "SaleReturn_List": "売上返品 - 一覧",
        "SaleReturn_Search": "売上返品を検索...",

        // フィルター
        "today": "今日",
        "yesterday": "昨日",
        "last_7_days": "過去7日間",
        "this_month": "今月",
        "last_month": "先月",
        "custome": "カスタム",

        // 曜日
        "sunday": "日曜日",
        "monday": "月曜日",
        "tuesday": "火曜日",
        "wednesday": "水曜日",
        "thursday": "木曜日",
        "friday": "金曜日",
        "saturday": "土曜日",

        // 費用
        "expense_list": "費用 - 一覧",
        "Expense_Name": "費用名",
        "Expense_Date": "費用日",
        "Payment_Method": "支払い方法",
        "Add_expense": "費用を追加",
        "Search_expenses": "費用を検索...",
        "Expense_Category": "費用カテゴリ",
        "Enter_Expense_Name": "名前を入力",
        "Enter_Expense_Description": "説明を入力",
        "Expense_add_success_message": "経費が正常に作成されました！",
        "Expense_add_failed_message": "経費の作成に失敗しました。もう一度お試しください！",
        "Expense_edit_success_message": "経費が正常に更新されました！",
        "Expense_edit_failed_message": "経費の更新に失敗しました。もう一度お試しください！",
        "Expense_delete_success_message": "経費が正常に削除されました！",
        "Expense_delete_failed_message": "経費の削除に失敗しました。もう一度お試しください！",
        "Expense_delete_conformation_text": "この経費を削除してもよろしいですか？",
        "expense_edit": "経費を編集",
        "delete": "削除",


        "cash": "現金",
        "upi": "UPI",
        "cheque": "小切手",
        "card": "カード",
        "electronics": "電子機器",
        "SaleReturn_List": "販売返品 - リスト",
        "SaleReturn_Search": "販売返品を検索...",
        "SaleReturn_add": "売上返品の追加",
        "SaleReturn_add_success_message": "売上返品が正常に作成されました！",
        "SaleReturn_add_failed_message": "売上返品の作成に失敗しました。もう一度お試しください！",
        "SaleReturn_edit_success_message": "売上返品が正常に更新されました！",
        "SaleReturn_edit_failed_message": "売上返品の更新に失敗しました。もう一度お試しください！",
        "SaleReturn_delete_success_message": "売上返品が正常に削除されました！",
        "SaleReturn_delete_failed_message": "売上返品の削除に失敗しました。もう一度お試しください！",
        "SaleReturn_delete_conformation_text": "この売上返品を削除してもよろしいですか？",
        "SaleReturn_edit": "売上返品の編集",
        "SaleReturn_Reason": "売上返品の理由",
        "SaleReturn_Reason_enter": "理由を入力してください",
        "SaleReturn_Reason_note": "売上請求書が支払われていないため、この売上返品では取引は行われません。",

        // 通貨
        "Country_name": "国名",
        "Country_code": "国コード",
        "Country_symbol": "通貨記号",
        "Country_flag": "国旗",
        "search_by": "国または通貨コードで検索"
    },
    "ch": {
        // 侧边栏
        "dashboard": "仪表盘",
        "business": "业务",
        "invoice": "发票",
        "customers": "客户",
        "sold_items": "已售商品",
        "expense": "费用",
        "currency": "货币",
        "sale_return": "销售退货",
        "premium_access": "高级访问",
        "valid_until": "有效期至",

        // 通用
        "view_all": "查看全部",
        "back": "返回",
        "add": "添加",
        "update": "更新",
        "cancel": "取消",
        "save": "保存",
        "edit": "编辑",
        "print": "打印",
        "download": "下载",
        "All": "全部",
        "All_Business": "所有业务",

        // 仪表盘
        "bannerTitle": "BillNama - 轻松管理您的发票、商品和客户",
        "bannerDesc": "轻松跟踪您的每日发票，管理商品，并将客户记录保存在一个地方。BillNama 简化了您的账单流程，节省时间，并帮助您保持井井有条。",
        "create_new": "创建新发票",
        "business_overview_Insights": "业务概览与分析",
        "total_earning": "总收入",
        "total_paid_earning": "已支付收入",
        "total_unpaid_earning": "未支付收入",
        "total_business": "总业务数",
        "total_invoices": "总发票数",
        "total_customers": "总客户数",
        "total_sold_items": "总销售商品数",
        "recent_invoice": "最近的发票",
        "recent_businesses": "最近的业务",
        "paid_earning": "已支付收入",
        "unpaid_earning": "未支付收入",
        "total_expense": "总费用",
        "total_salereturn": "总销售退货",
        "Total_Earnings_Expense": "总收入与费用",
        "Session": "会话",
        "billing": "支付记录",
        "Delete_My_Account": "删除我的账户",
        "Log_Out": "退出登录",

        // 业务
        "business_list": "业务 - 列表",
        "search_business": "搜索业务...",
        "create_business": "创建业务",
        "business_logo": "业务标志",
        "business_name": "业务名称",
        "gst_number": "GST 号码",
        "invoice": "发票",
        "customers": "客户",
        "issued_date": "发行日期",
        "action": "操作",
        "entries_per_page": "每页条目数",

        // 查看业务
        "view_business": "查看业务",
        "business_info": "业务信息",
        "address": "地址",
        "tc_account_details": "条款和条件 / 账户详情",

        // 添加/编辑业务
        "add_business": "创建新业务",
        "edit_business": "编辑业务",
        "business_name_error": "请输入有效的业务名称！",
        "enter_business_name": "输入业务名称",
        "enter_gst_number": "输入 GST 号码",
        "enter_address": "输入地址",
        "enter_tc_account_details": "输入条款和条件 / 账户详情",
        "business_add_success_message": "业务创建成功！",
        "business_add_failed_message": "业务创建失败，请重试！",

        // 发票
        "invoice_list": "发票 - 列表",
        "search_invoices": "搜索发票...",
        "create_invoices": "创建发票",
        "invoice_no": "发票编号",
        "customer_name": "客户名称",
        "amount": "金额",
        "issued_date": "发行日期",
        "status": "状态",
        "paid": "已支付",
        "unpaid": "未支付",

        // 客户
        "customers_list": "客户 - 列表",
        "search_customer": "搜索客户...",
        "phone": "电话",
        "total_amount": "总金额",
        "view_customer": "查看客户",
        "name": "名称",
        "GST": "GST",
        "related_invoices": "相关发票",
        "creation_date": "创建日期",
        "invoice_delete_success_message": "发票已成功删除！",
        "inoive_delete_failed_message": "删除发票失败，请重试！",
        "inoive_delete_conformation_text": "您确定要删除此发票吗？",
        "inoive_delete_conformation": "确认删除",

        "Expense_add_success_message": "経費が正常に作成されました！",
        "Expense_add_failed_message": "経費の作成に失敗しました。もう一度お試しください！",
        "Expense_edit_success_message": "経費が正常に更新されました！",
        "Expense_edit_failed_message": "経費の更新に失敗しました。もう一度お試しください！",
        "Expense_delete_success_message": "経費が正常に削除されました！",
        "Expense_delete_failed_message": "経費の削除に失敗しました。もう一度お試しください！",
        "Expense_delete_conformation_text": "この経費を削除してもよろしいですか？",
        "expense_edit": "経費を編集",
        "delete": "削除",

        // 销售退货
        "SaleReturn_List": "销售退货 - 列表",
        "SaleReturn_Search": "搜索销售退货...",

        "SaleReturn_add": "新增销售退货",
        "SaleReturn_add_success_message": "销售退货创建成功！",
        "SaleReturn_add_failed_message": "创建销售退货失败，请重试！",
        "SaleReturn_edit_success_message": "销售退货更新成功！",
        "SaleReturn_edit_failed_message": "更新销售退货失败，请重试！",
        "SaleReturn_delete_success_message": "销售退货删除成功！",
        "SaleReturn_delete_failed_message": "删除销售退货失败，请重试！",
        "SaleReturn_delete_conformation_text": "您确定要删除此销售退货吗？",
        "SaleReturn_edit": "编辑销售退货",
        "SaleReturn_Reason": "销售退货原因",
        "SaleReturn_Reason_enter": "请输入原因",
        "SaleReturn_Reason_note": "销售发票未付款，因此此次销售退货将不会发生交易。",



        // 过滤
        "today": "今天",
        "yesterday": "昨天",
        "last_7_days": "过去7天",
        "this_month": "本月",
        "last_month": "上月",
        "custome": "自定义",

        // 星期
        "sunday": "星期天",
        "monday": "星期一",
        "tuesday": "星期二",
        "wednesday": "星期三",
        "thursday": "星期四",
        "friday": "星期五",
        "saturday": "星期六",

        // 费用
        "expense_list": "费用 - 列表",
        "Expense_Name": "费用名称",
        "Expense_Date": "费用日期",
        "Payment_Method": "支付方式",
        "Add_expense": "添加费用",
        "Search_expenses": "搜索费用...",
        "Expense_Category": "费用类别",
        "Enter_Expense_Name": "输入名称",
        "Enter_Expense_Description": "输入描述",

        "cash": "现金",
        "upi": "UPI",
        "cheque": "支票",
        "card": "银行卡",
        "electronics": "电子产品",

        // 货币
        "Country_name": "国家名称",
        "Country_code": "国家代码",
        "Country_symbol": "货币符号",
        "Country_flag": "国旗",
        "search_by": "按国家或货币代码搜索"
    },
    "ko": {
        // 사이드바
        "dashboard": "대시보드",
        "business": "비즈니스",
        "invoice": "송장",
        "customers": "고객",
        "sold_items": "판매된 상품",
        "expense": "비용",
        "currency": "통화",
        "sale_return": "판매 반품",
        "premium_access": "프리미엄 액세스",
        "valid_until": "유효 기간",

        // 공통
        "view_all": "모두 보기",
        "back": "뒤로",
        "add": "추가",
        "update": "업데이트",
        "cancel": "취소",
        "save": "저장",
        "edit": "편집",
        "print": "인쇄",
        "download": "다운로드",
        "All": "전체",
        "All_Business": "전체 비즈니스",

        // 대시보드
        "bannerTitle": "BillNama - 송장, 상품 및 고객을 쉽게 관리하세요",
        "bannerDesc": "일일 송장을 추적하고, 상품을 관리하며, 고객 기록을 한 곳에서 유지하세요. BillNama는 청구 프로세스를 간소화하고 시간을 절약하며 체계적으로 정리하는 데 도움이 됩니다.",
        "create_new": "새 송장 만들기",
        "business_overview_Insights": "비즈니스 개요 및 인사이트",
        "total_earning": "총 수입",
        "total_paid_earning": "총 지불된 수입",
        "total_unpaid_earning": "총 미지급 수입",
        "total_business": "총 비즈니스 수",
        "total_invoices": "총 송장 수",
        "total_customers": "총 고객 수",
        "total_sold_items": "총 판매된 상품 수",
        "recent_invoice": "최근 송장",
        "recent_businesses": "최근 비즈니스",
        "paid_earning": "지불된 수입",
        "unpaid_earning": "미지급 수입",
        "total_expense": "총 비용",
        "total_salereturn": "총 판매 반품",
        "Total_Earnings_Expense": "총 수익 및 비용",
        "Session": "세션",
        "billing": "결제 기록",
        "Delete_My_Account": "내 계정 삭제",
        "Log_Out": "로그아웃",

        // 비즈니스
        "business_list": "비즈니스 - 목록",
        "search_business": "비즈니스 검색...",
        "create_business": "비즈니스 생성",
        "business_logo": "비즈니스 로고",
        "business_name": "비즈니스 이름",
        "gst_number": "GST 번호",
        "invoice": "송장",
        "customers": "고객",
        "issued_date": "발행 날짜",
        "action": "작업",
        "entries_per_page": "페이지당 항목 수",

        // 비즈니스 보기
        "view_business": "비즈니스 보기",
        "business_info": "비즈니스 정보",
        "address": "주소",
        "tc_account_details": "약관 / 계정 정보",

        // 비즈니스 추가/편집
        "add_business": "새 비즈니스 생성",
        "edit_business": "비즈니스 편집",
        "business_name_error": "유효한 비즈니스 이름을 입력하세요!",
        "enter_business_name": "비즈니스 이름 입력",
        "enter_gst_number": "GST 번호 입력",
        "enter_address": "주소 입력",
        "enter_tc_account_details": "약관 / 계정 정보 입력",
        "business_add_success_message": "비즈니스가 성공적으로 생성되었습니다!",
        "business_add_failed_message": "비즈니스 생성에 실패했습니다. 다시 시도하세요!",
        "creation_date": "생성 날짜",
        "invoice_delete_success_message": "송장이 성공적으로 삭제되었습니다!",
        "inoive_delete_failed_message": "송장 삭제에 실패했습니다. 다시 시도해 주세요!",
        "inoive_delete_conformation_text": "이 송장을 삭제하시겠습니까?",
        "inoive_delete_conformation": "삭제 확인",

        // 송장
        "invoice_list": "송장 - 목록",
        "search_invoices": "송장 검색...",
        "create_invoices": "송장 만들기",
        "invoice_no": "송장 번호",
        "customer_name": "고객 이름",
        "amount": "금액",
        "issued_date": "발행 날짜",
        "status": "상태",
        "paid": "지불됨",
        "unpaid": "미지불됨",

        // 고객
        "customers_list": "고객 - 목록",
        "search_customer": "고객 검색...",
        "phone": "전화번호",
        "total_amount": "총 금액",
        "view_customer": "고객 보기",
        "name": "이름",
        "GST": "GST",
        "related_invoices": "관련 송장",

        // 판매 반품
        "SaleReturn_List": "판매 반품 - 목록",
        "SaleReturn_Search": "판매 반품 검색...",

        // 필터
        "today": "오늘",
        "yesterday": "어제",
        "last_7_days": "지난 7일",
        "this_month": "이번 달",
        "last_month": "지난 달",
        "custome": "사용자 지정",

        // 요일
        "sunday": "일요일",
        "monday": "월요일",
        "tuesday": "화요일",
        "wednesday": "수요일",
        "thursday": "목요일",
        "friday": "금요일",
        "saturday": "토요일",

        // 비용
        "expense_list": "비용 - 목록",
        "Expense_Name": "비용 이름",
        "Expense_Date": "비용 날짜",
        "Payment_Method": "결제 방법",
        "Add_expense": "비용 추가",
        "Search_expenses": "비용 검색...",
        "Expense_Category": "비용 카테고리",
        "Enter_Expense_Name": "이름 입력",
        "Enter_Expense_Description": "설명 입력",
        "Expense_add_success_message": "지출이 성공적으로 생성되었습니다!",
        "Expense_add_failed_message": "지출 생성에 실패했습니다. 다시 시도해 주세요!",
        "Expense_edit_success_message": "지출이 성공적으로 업데이트되었습니다!",
        "Expense_edit_failed_message": "지출 업데이트에 실패했습니다. 다시 시도해 주세요!",
        "Expense_delete_success_message": "지출이 성공적으로 삭제되었습니다!",
        "Expense_delete_failed_message": "지출 삭제에 실패했습니다. 다시 시도해 주세요!",
        "Expense_delete_conformation_text": "이 지출을 삭제하시겠습니까?",
        "expense_edit": "지출 편집",
        "delete": "삭제",

        "cash": "현금",
        "upi": "UPI",
        "cheque": "수표",
        "card": "카드",
        "electronics": "전자제품",


        "SaleReturn_add": "판매 반품 추가",
        "SaleReturn_add_success_message": "판매 반품이 성공적으로 생성되었습니다!",
        "SaleReturn_add_failed_message": "판매 반품 생성에 실패했습니다. 다시 시도해 주세요!",
        "SaleReturn_edit_success_message": "판매 반품이 성공적으로 업데이트되었습니다!",
        "SaleReturn_edit_failed_message": "판매 반품 업데이트에 실패했습니다. 다시 시도해 주세요!",
        "SaleReturn_delete_success_message": "판매 반품이 성공적으로 삭제되었습니다!",
        "SaleReturn_delete_failed_message": "판매 반품 삭제에 실패했습니다. 다시 시도해 주세요!",
        "SaleReturn_delete_conformation_text": "이 판매 반품을 삭제하시겠습니까?",
        "SaleReturn_edit": "판매 반품 편집",
        "SaleReturn_Reason": "판매 반품 사유",
        "SaleReturn_Reason_enter": "사유를 입력하세요",
        "SaleReturn_Reason_note": "판매 인보이스가 결제되지 않아 이번 반품에서는 거래가 발생하지 않습니다.",

        // 통화
        "Country_name": "국가명",
        "Country_code": "국가 코드",
        "Country_symbol": "통화 기호",
        "Country_flag": "국기",
        "search_by": "국가 또는 통화 코드로 검색"
    },
    "ms": {
        // Bar sisi
        "dashboard": "Papan Pemuka",
        "business": "Perniagaan",
        "invoice": "Invois",
        "customers": "Pelanggan",
        "sold_items": "Barang Terjual",
        "expense": "Perbelanjaan",
        "currency": "Mata Wang",
        "sale_return": "Pemulangan Jualan",
        "premium_access": "Akses Premium",
        "valid_until": "Sah Sehingga",

        // Umum
        "view_all": "Lihat Semua",
        "back": "Kembali",
        "add": "Tambah",
        "update": "Kemaskini",
        "cancel": "Batal",
        "save": "Simpan",
        "edit": "Edit",
        "print": "Cetak",
        "download": "Muat Turun",
        "All": "Semua",
        "All_Business": "Semua Perniagaan",

        // Papan Pemuka
        "bannerTitle": "BillNama - Urus Invois, Barang & Pelanggan Anda Dengan Mudah",
        "bannerDesc": "Jejaki invois harian anda, urus barang dan simpan rekod pelanggan di satu tempat. BillNama memudahkan proses pengebilan anda, menjimatkan masa, dan membantu anda menjadi lebih teratur.",
        "create_new": "Buat Invois Baru",
        "business_overview_Insights": "Gambaran Keseluruhan & Wawasan Perniagaan",
        "total_earning": "Jumlah Pendapatan",
        "total_paid_earning": "Jumlah Pendapatan Dibayar",
        "total_unpaid_earning": "Jumlah Pendapatan Belum Dibayar",
        "total_business": "Jumlah Perniagaan",
        "total_invoices": "Jumlah Invois",
        "total_customers": "Jumlah Pelanggan",
        "total_sold_items": "Jumlah Barang Terjual",
        "recent_invoice": "Invois Terkini",
        "recent_businesses": "Perniagaan Terkini",
        "paid_earning": "Pendapatan Dibayar",
        "unpaid_earning": "Pendapatan Belum Dibayar",
        "total_expense": "Jumlah Perbelanjaan",
        "total_salereturn": "Jumlah Pemulangan Jualan",
        "Total_Earnings_Expense": "Jumlah Pendapatan & Perbelanjaan",
        "Session": "Sesi",
        "billing": "Sejarah Pembayaran",
        "Delete_My_Account": "Padam Akaun Saya",
        "Log_Out": "Log Keluar",

        // Perniagaan
        "business_list": "Senarai Perniagaan",
        "search_business": "Cari Perniagaan...",
        "create_business": "Buat Perniagaan",
        "business_logo": "Logo Perniagaan",
        "business_name": "Nama Perniagaan",
        "gst_number": "Nombor GST",
        "invoice": "Invois",
        "customers": "Pelanggan",
        "issued_date": "Tarikh Dikeluarkan",
        "action": "Tindakan",
        "entries_per_page": "Entri setiap halaman",

        // Lihat Perniagaan
        "view_business": "Lihat Perniagaan",
        "business_info": "Maklumat Perniagaan",
        "address": "Alamat",
        "tc_account_details": "Terma & Syarat / Maklumat Akaun",

        // Tambah/Edit Perniagaan
        "add_business": "Cipta Perniagaan Baru",
        "edit_business": "Edit Perniagaan",
        "business_name_error": "Sila masukkan nama perniagaan yang sah!",
        "enter_business_name": "Masukkan Nama Perniagaan",
        "enter_gst_number": "Masukkan Nombor GST",
        "enter_address": "Masukkan Alamat",
        "enter_tc_account_details": "Masukkan Terma & Syarat / Maklumat Akaun",
        "business_add_success_message": "Perniagaan berjaya dicipta!",
        "business_add_failed_message": "Gagal mencipta perniagaan. Sila cuba lagi!",

        // Invois
        "invoice_list": "Senarai Invois",
        "search_invoices": "Cari Invois...",
        "create_invoices": "Buat Invois",
        "invoice_no": "Nombor Invois",
        "customer_name": "Nama Pelanggan",
        "amount": "Jumlah",
        "issued_date": "Tarikh Dikeluarkan",
        "status": "Status",
        "paid": "Dibayar",
        "unpaid": "Belum Dibayar",
        "creation_date": "Tarikh Ciptaan",
        "invoice_delete_success_message": "Invois berjaya dipadam!",
        "inoive_delete_failed_message": "Gagal memadam invois, sila cuba lagi!",
        "inoive_delete_conformation_text": "Adakah anda pasti mahu memadam invois ini?",
        "inoive_delete_conformation": "Sahkan Pemadaman",

        // Pelanggan
        "customers_list": "Senarai Pelanggan",
        "search_customer": "Cari Pelanggan...",
        "phone": "Telefon",
        "total_amount": "Jumlah Keseluruhan",
        "view_customer": "Lihat Pelanggan",
        "name": "Nama",
        "GST": "GST",
        "related_invoices": "Invois Berkaitan",
        "Expense_add_success_message": "Perbelanjaan berjaya ditambah!",
        "Expense_add_failed_message": "Gagal menambah perbelanjaan, sila cuba lagi!",
        "Expense_edit_success_message": "Perbelanjaan berjaya dikemas kini!",
        "Expense_edit_failed_message": "Gagal mengemas kini perbelanjaan, sila cuba lagi!",
        "Expense_delete_success_message": "Perbelanjaan berjaya dipadam!",
        "Expense_delete_failed_message": "Gagal memadam perbelanjaan, sila cuba lagi!",
        "Expense_delete_conformation_text": "Adakah anda pasti mahu memadam perbelanjaan ini?",
        "expense_edit": "Edit Perbelanjaan",
        "delete": "Padam",

        // Pemulangan Jualan
        "SaleReturn_List": "Senarai Pemulangan Jualan",
        "SaleReturn_Search": "Cari Pemulangan Jualan...",
        "SaleReturn_add": "Tambah Pemulangan Jualan",
        "SaleReturn_add_success_message": "Pemulangan jualan berjaya ditambah!",
        "SaleReturn_add_failed_message": "Gagal menambah pemulangan jualan, sila cuba lagi!",
        "SaleReturn_edit_success_message": "Pemulangan jualan berjaya dikemas kini!",
        "SaleReturn_edit_failed_message": "Gagal mengemas kini pemulangan jualan, sila cuba lagi!",
        "SaleReturn_delete_success_message": "Pemulangan jualan berjaya dipadam!",
        "SaleReturn_delete_failed_message": "Gagal memadam pemulangan jualan, sila cuba lagi!",
        "SaleReturn_delete_conformation_text": "Adakah anda pasti mahu memadam pemulangan jualan ini?",
        "SaleReturn_edit": "Edit Pemulangan Jualan",
        "SaleReturn_Reason": "Sebab Pemulangan Jualan",
        "SaleReturn_Reason_enter": "Masukkan sebab",
        "SaleReturn_Reason_note": "Invois jualan tidak dibayar, jadi tiada transaksi akan berlaku dalam pemulangan jualan ini.",


        // Penapis
        "today": "Hari Ini",
        "yesterday": "Semalam",
        "last_7_days": "7 Hari Terakhir",
        "this_month": "Bulan Ini",
        "last_month": "Bulan Lepas",
        "custome": "Tersuai",

        // Hari dalam seminggu
        "sunday": "Ahad",
        "monday": "Isnin",
        "tuesday": "Selasa",
        "wednesday": "Rabu",
        "thursday": "Khamis",
        "friday": "Jumaat",
        "saturday": "Sabtu",

        // Perbelanjaan
        "expense_list": "Senarai Perbelanjaan",
        "Expense_Name": "Nama Perbelanjaan",
        "Expense_Date": "Tarikh Perbelanjaan",
        "Payment_Method": "Kaedah Pembayaran",
        "Add_expense": "Tambah Perbelanjaan",
        "Search_expenses": "Cari Perbelanjaan...",
        "Expense_Category": "Kategori Perbelanjaan",
        "Enter_Expense_Name": "Masukkan Nama",
        "Enter_Expense_Description": "Masukkan Keterangan",

        "cash": "Tunai",
        "upi": "UPI",
        "cheque": "Cek",
        "card": "Kad",
        "electronics": "Elektronik",

        // Mata Wang
        "Country_name": "Nama Negara",
        "Country_code": "Kod Negara",
        "Country_symbol": "Simbol Mata Wang",
        "Country_flag": "Bendera Negara",
        "search_by": "Cari berdasarkan Kod Negara atau Mata Wang"
    },
    "ta": {
        // பக்கப்பட்டி
        "dashboard": "டாஷ்போர்டு",
        "business": "வணிகம்",
        "invoice": "விலைப்பட்டியல்",
        "customers": "வாடிக்கையாளர்கள்",
        "sold_items": "விற்ற பொருட்கள்",
        "expense": "செலவு",
        "currency": "நாணயம்",
        "sale_return": "விற்பனை திரும்பல்",
        "premium_access": "பிரீமியம் அணுகல்",
        "valid_until": "செல்லுபடியாகும் வரை",

        // பொதுவானவை
        "view_all": "அனைத்தையும் காட்டு",
        "back": "பின்செல்",
        "add": "சேர்க்க",
        "update": "புதுப்பிக்க",
        "cancel": "ரத்து செய்",
        "save": "சேமிக்க",
        "edit": "திருத்து",
        "print": "அச்சிடு",
        "download": "பதிவிறக்கு",
        "All": "அனைத்து",
        "All_Business": "அனைத்து வணிகங்கள்",

        // டாஷ்போர்டு
        "bannerTitle": "BillNama - உங்கள் விலைப்பட்டியல், பொருட்கள் & வாடிக்கையாளர்களை எளிதாக நிர்வகிக்கவும்",
        "bannerDesc": "உங்கள் தினசரி விலைப்பட்டியல்களை கண்காணிக்கவும், பொருட்களை நிர்வகிக்கவும், வாடிக்கையாளர்களின் தகவல்களை ஒரே இடத்தில் சேமிக்கவும். BillNama உங்கள் பில்லிங் செயல்முறையை எளிதாக்குகிறது, நேரத்தை மிச்சப்படுத்துகிறது, மற்றும் அமைதியாக இருக்க உதவுகிறது.",
        "create_new": "புதிய விலைப்பட்டியல் உருவாக்கு",
        "business_overview_Insights": "வணிக மேலோட்டம் & நுண்ணறிவு",
        "total_earning": "மொத்த வருமானம்",
        "total_paid_earning": "மொத்த செலுத்தப்பட்ட வருமானம்",
        "total_unpaid_earning": "மொத்த செலுத்தப்படாத வருமானம்",
        "total_business": "மொத்த வணிகம்",
        "total_invoices": "மொத்த விலைப்பட்டியல்",
        "total_customers": "மொத்த வாடிக்கையாளர்கள்",
        "total_sold_items": "மொத்த விற்ற பொருட்கள்",
        "recent_invoice": "சமீபத்திய விலைப்பட்டியல்",
        "recent_businesses": "சமீபத்திய வணிகங்கள்",
        "paid_earning": "செலுத்தப்பட்ட வருமானம்",
        "unpaid_earning": "செலுத்தப்படாத வருமானம்",
        "total_expense": "மொத்த செலவு",
        "total_salereturn": "மொத்த விற்பனை திரும்பல்",
        "Total_Earnings_Expense": "மொத்த வருமானம் & செலவு",
        "Session": "அமர்வு",
        "billing": "கட்டண வரலாறு",
        "Delete_My_Account": "என் கணக்கை நீக்கு",
        "Log_Out": "வெளியேறு",

        // வணிகம்
        "business_list": "வணிக பட்டியல்",
        "search_business": "வணிகத்தை தேடு...",
        "create_business": "வணிகம் உருவாக்கு",
        "business_logo": "வணிக லோகோ",
        "business_name": "வணிகத்தின் பெயர்",
        "gst_number": "GST எண்",
        "invoice": "விலைப்பட்டியல்",
        "customers": "வாடிக்கையாளர்கள்",
        "issued_date": "வெளியீட்டு தேதி",
        "action": "செயல்",
        "entries_per_page": "ஒரு பக்கத்திற்கு உள்ளிடங்கள்",
        "creation_date": "உருவாக்கப்பட்ட தேதி",
        "invoice_delete_success_message": "விலைப்பட்டியல் வெற்றிகரமாக நீக்கப்பட்டது!",
        "inoive_delete_failed_message": "விலைப்பட்டியலை நீக்க முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
        "inoive_delete_conformation_text": "இந்த விலைப்பட்டியலை நீக்க விரும்புகிறீர்களா?",
        "inoive_delete_conformation": "நீக்குதலை உறுதிப்படுத்தவும்",

        // வாடிக்கையாளர்கள்
        "customers_list": "வாடிக்கையாளர் பட்டியல்",
        "search_customer": "வாடிக்கையாளரை தேடு...",
        "phone": "தொலைபேசி",
        "total_amount": "மொத்த தொகை",
        "view_customer": "வாடிக்கையாளரை காண்க",
        "name": "பெயர்",
        "GST": "GST",
        "related_invoices": "தொடர்புடைய விலைப்பட்டியல்கள்",

        // விற்பனை திரும்பல்
        "SaleReturn_List": "விற்பனை திரும்பல் பட்டியல்",
        "SaleReturn_Search": "விற்பனை திரும்பலை தேடு...",

        // வடிகட்டல்
        "today": "இன்று",
        "yesterday": "நேற்று",
        "last_7_days": "கடந்த 7 நாட்கள்",
        "this_month": "இந்த மாதம்",
        "last_month": "கடந்த மாதம்",
        "custome": "தனிப்பயன்",

        // வார நாட்கள்
        "sunday": "ஞாயிறு",
        "monday": "திங்கள்",
        "tuesday": "செவ்வாய்",
        "wednesday": "புதன்",
        "thursday": "வியாழன்",
        "friday": "வெள்ளி",
        "saturday": "சனி",

        // செலவு
        "expense_list": "செலவு பட்டியல்",
        "Expense_Name": "செலவு பெயர்",
        "Expense_Date": "செலவு தேதி",
        "Payment_Method": "கட்டண முறைகள்",
        "Add_expense": "செலவு சேர்க்க",
        "Search_expenses": "செலவுகளை தேடு...",
        "Expense_Category": "செலவு வகை",
        "Enter_Expense_Name": "பெயரை உள்ளிடு",
        "Enter_Expense_Description": "விவரத்தை உள்ளிடு",
        "Expense_add_success_message": "செலவு வெற்றிகரமாக உருவாக்கப்பட்டது!",
        "Expense_add_failed_message": "செலவை உருவாக்க முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
        "Expense_edit_success_message": "செலவு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
        "Expense_edit_failed_message": "செலவை புதுப்பிக்க முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
        "Expense_delete_success_message": "செலவு வெற்றிகரமாக நீக்கப்பட்டது!",
        "Expense_delete_failed_message": "செலவை நீக்க முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
        "Expense_delete_conformation_text": "இந்த செலவை நீக்க விரும்புகிறீர்களா?",
        "expense_edit": "செலவைத் திருத்து",
        "delete": "நீக்கு",

        "cash": "பணம்",
        "upi": "UPI",
        "cheque": "காசோலை",
        "card": "அட்டை",
        "electronics": "மின்னணு",

        "SaleReturn_add": "விற்பனை மீட்டல் சேர்க்க",
        "SaleReturn_add_success_message": "விற்பனை மீட்டல் வெற்றிகரமாக உருவாக்கப்பட்டது!",
        "SaleReturn_add_failed_message": "விற்பனை மீட்டலை உருவாக்க முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
        "SaleReturn_edit_success_message": "விற்பனை மீட்டல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
        "SaleReturn_edit_failed_message": "விற்பனை மீட்டலை புதுப்பிக்க முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
        "SaleReturn_delete_success_message": "விற்பனை மீட்டல் வெற்றிகரமாக நீக்கப்பட்டது!",
        "SaleReturn_delete_failed_message": "விற்பனை மீட்டலை நீக்க முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
        "SaleReturn_delete_conformation_text": "இந்த விற்பனை மீட்டலை நீக்க விரும்புகிறீர்களா?",
        "SaleReturn_edit": "விற்பனை மீட்டலைத் திருத்து",
        "SaleReturn_Reason": "விற்பனை மீட்டல் காரணம்",
        "SaleReturn_Reason_enter": "ஒரு காரணத்தை உள்ளிடவும்",
        "SaleReturn_Reason_note": "விற்பனை ரசீது செலுத்தப்படவில்லை, எனவே இந்த விற்பனை மீட்டலில் எந்தவொரு பரிவர்த்தனையும் நடைபெறாது.",

        // நாணயம்
        "Country_name": "நாட்டின் பெயர்",
        "Country_code": "நாட்டு குறியீடு",
        "Country_symbol": "நாணய குறியீடு",
        "Country_flag": "கொடி",
        "search_by": "நாட்டு அல்லது நாணய குறியீடு மூலம் தேடவும்"
    },
    "te": {
        // పక్కపట్టీ
        "dashboard": "డాష్‌బోర్డ్",
        "business": "వ్యాపారం",
        "invoice": "ఇన్‌వాయిస్",
        "customers": "కస్టమర్లు",
        "sold_items": "అమ్మిన వస్తువులు",
        "expense": "ఖర్చు",
        "currency": "కరెన్సీ",
        "sale_return": "అమ్మకం రీటర్న్",
        "premium_access": "ప్రీమియం యాక్సెస్",
        "valid_until": "చెల్లుబాటు అవుతుంది",

        // సాధారణంగా
        "view_all": "అన్నీ చూడండి",
        "back": "వెనక్కి",
        "add": "జోడించండి",
        "update": "నవీకరణ",
        "cancel": "రద్దు చేయండి",
        "save": "సేవ్ చేయండి",
        "edit": "సవరించండి",
        "print": "ముద్రించండి",
        "download": "డౌన్‌లోడ్ చేయండి",
        "All": "అన్నీ",
        "All_Business": "అన్ని వ్యాపారాలు",

        // డాష్‌బోర్డ్
        "bannerTitle": "BillNama - మీ ఇన్‌వాయిస్లు, వస్తువులు & కస్టమర్లను సులభంగా నిర్వహించండి",
        "bannerDesc": "మీ రోజువారీ ఇన్‌వాయిస్లను ట్రాక్ చేయండి, వస్తువులను నిర్వహించండి, మరియు కస్టమర్ రికార్డులను ఒకే చోట భద్రపరచండి. BillNama మీ బిల్లింగ్ ప్రక్రియను సులభతరం చేస్తుంది, సమయాన్ని ఆదా చేస్తుంది, మరియు నిర్వహణను సులభతరం చేస్తుంది.",
        "create_new": "కొత్త ఇన్‌వాయిస్ సృష్టించండి",
        "business_overview_Insights": "వ్యాపార అవలోకనం & విశ్లేషణలు",
        "total_earning": "మొత్తం ఆదాయం",
        "total_paid_earning": "మొత్తం చెల్లించిన ఆదాయం",
        "total_unpaid_earning": "మొత్తం చెల్లించని ఆదాయం",
        "total_business": "మొత్తం వ్యాపారం",
        "total_invoices": "మొత్తం ఇన్‌వాయిస్లు",
        "total_customers": "మొత్తం కస్టమర్లు",
        "total_sold_items": "మొత్తం అమ్మిన వస్తువులు",
        "recent_invoice": "ఇటీవల ఇన్‌వాయిస్",
        "recent_businesses": "ఇటీవల వ్యాపారాలు",
        "paid_earning": "చెల్లించిన ఆదాయం",
        "unpaid_earning": "చెల్లించని ఆదాయం",
        "total_expense": "మొత్తం ఖర్చు",
        "total_salereturn": "మొత్తం అమ్మకపు రీటర్న్",
        "Total_Earnings_Expense": "మొత్తం ఆదాయం & ఖర్చు",
        "Session": "సెషన్",
        "billing": "చెల్లింపు చరిత్ర",
        "Delete_My_Account": "నా ఖాతాను తొలగించండి",
        "Log_Out": "లాగ్అవుట్ చేయండి",

        // వ్యాపారం
        "business_list": "వ్యాపారాల జాబితా",
        "search_business": "వ్యాపారం కోసం వెతకండి...",
        "create_business": "కొత్త వ్యాపారం సృష్టించండి",
        "business_logo": "వ్యాపార లోగో",
        "business_name": "వ్యాపార పేరు",
        "gst_number": "GST నంబర్",
        "invoice": "ఇన్‌వాయిస్",
        "customers": "కస్టమర్లు",
        "issued_date": "జారీ చేసిన తేదీ",
        "action": "కార్యాచరణ",
        "entries_per_page": "ప్రతి పేజీకి నమోదు లు",
        "creation_date": "సృష్టించిన తేదీ",
        "invoice_delete_success_message": "ఇన్వాయిస్ విజయవంతంగా తొలగించబడింది!",
        "inoive_delete_failed_message": "ఇన్వాయిస్‌ను తొలగించలేకపోయాం, దయచేసి మళ్లీ ప్రయత్నించండి!",
        "inoive_delete_conformation_text": "ఈ ఇన్వాయిస్‌ను మీరు నిజంగా తొలగించాలనుకుంటున్నారా?",
        "inoive_delete_conformation": "తొలగింపును నిర్ధారించండి",

        // కస్టమర్లు
        "customers_list": "కస్టమర్ల జాబితా",
        "search_customer": "కస్టమర్‌ను వెతకండి...",
        "phone": "ఫోన్",
        "total_amount": "మొత్తం మొత్తం",
        "view_customer": "కస్టమర్‌ను చూడండి",
        "name": "పేరు",
        "GST": "GST",
        "related_invoices": "సంబంధిత ఇన్‌వాయిస్లు",
        "Expense_add_success_message": "ఖర్చు విజయవంతంగా సృష్టించబడింది!",
        "Expense_add_failed_message": "ఖర్చును సృష్టించడంలో విఫలమయ్యారు, దయచేసి మళ్లీ ప్రయత్నించండి!",
        "Expense_edit_success_message": "ఖర్చు విజయవంతంగా నవీకరించబడింది!",
        "Expense_edit_failed_message": "ఖర్చును నవీకరించడంలో విఫలమయ్యారు, దయచేసి మళ్లీ ప్రయత్నించండి!",
        "Expense_delete_success_message": "ఖర్చు విజయవంతంగా తొలగించబడింది!",
        "Expense_delete_failed_message": "ఖర్చును తొలగించడంలో విఫలమయ్యారు, దయచేసి మళ్లీ ప్రయత్నించండి!",
        "Expense_delete_conformation_text": "మీరు ఈ ఖర్చును నిజంగా తొలగించాలనుకుంటున్నారా?",
        "expense_edit": "ఖర్చును సరిచూడండి",
        "delete": "తొలగించు",

        // అమ్మకపు రీటర్న్
        "SaleReturn_List": "అమ్మకపు రీటర్న్ జాబితా",
        "SaleReturn_Search": "అమ్మకపు రీటర్న్ కోసం వెతకండి...",

        "SaleReturn_add": "విక్రయ రిటర్న్ జోడించండి",
        "SaleReturn_add_success_message": "విక్రయ రిటర్న్ విజయవంతంగా సృష్టించబడింది!",
        "SaleReturn_add_failed_message": "విక్రయ రిటర్న్ సృష్టించడంలో విఫలమయ్యారు, దయచేసి మళ్లీ ప్రయత్నించండి!",
        "SaleReturn_edit_success_message": "విక్రయ రిటర్న్ విజయవంతంగా నవీకరించబడింది!",
        "SaleReturn_edit_failed_message": "విక్రయ రిటర్న్ నవీకరణలో విఫలమయ్యారు, దయచేసి మళ్లీ ప్రయత్నించండి!",
        "SaleReturn_delete_success_message": "విక్రయ రిటర్న్ విజయవంతంగా తొలగించబడింది!",
        "SaleReturn_delete_failed_message": "విక్రయ రిటర్న్ తొలగించడంలో విఫలమయ్యారు, దయచేసి మళ్లీ ప్రయత్నించండి!",
        "SaleReturn_delete_conformation_text": "ఈ విక్రయ రిటర్న్‌ను మీరు ఖచ్చితంగా తొలగించాలనుకుంటున్నారా?",
        "SaleReturn_edit": "విక్రయ రిటర్న్ సరిచూడండి",
        "SaleReturn_Reason": "విక్రయ రిటర్న్ కారణం",
        "SaleReturn_Reason_enter": "కారణాన్ని నమోదు చేయండి",
        "SaleReturn_Reason_note": "విక్రయ చలానా చెల్లించబడలేదు కాబట్టి ఈ విక్రయ రిటర్న్‌లో ఎటువంటి లావాదేవీ జరగదు.",



        // ఫిల్టర్
        "today": "ఇవాళ",
        "yesterday": "నిన్న",
        "last_7_days": "గత 7 రోజులు",
        "this_month": "ఈ నెల",
        "last_month": "గత నెల",
        "custome": "కస్టమ్",

        // వారపు రోజులు
        "sunday": "ఆదివారం",
        "monday": "సోమవారం",
        "tuesday": "మంగళవారం",
        "wednesday": "బుధవారం",
        "thursday": "గురువారం",
        "friday": "శుక్రవారం",
        "saturday": "శనివారం",

        // ఖర్చు
        "expense_list": "ఖర్చుల జాబితా",
        "Expense_Name": "ఖర్చు పేరు",
        "Expense_Date": "ఖర్చు తేదీ",
        "Payment_Method": "చెల్లింపు విధానం",
        "Add_expense": "ఖర్చు జోడించండి",
        "Search_expenses": "ఖర్చును వెతకండి...",
        "Expense_Category": "ఖర్చు వర్గం",
        "Enter_Expense_Name": "పేరు నమోదు చేయండి",
        "Enter_Expense_Description": "వివరణ నమోదు చేయండి",

        "cash": "నగదు",
        "upi": "UPI",
        "cheque": "చెక్కు",
        "card": "కార్డ్",
        "electronics": "ఎలక్ట్రానిక్స్",

        // కరెన్సీ
        "Country_name": "దేశం పేరు",
        "Country_code": "దేశం కోడ్",
        "Country_symbol": "ప్రతీకం",
        "Country_flag": "పతాకం",
        "search_by": "దేశం లేదా కరెన్సీ కోడ్ ద్వారా వెతకండి"
    }


}